// Russian for the `planning` namespace. The readers are KazKabel's planners and
// facility admins. «Прогноз» for a forecast, «график производства» for the
// master schedule, «страховой запас» for safety stock, «площадка» for a
// facility. Counted nouns are not agreed with their number (D-030).

export const planningRuDict = {
  nav: {
    aria: "Разделы планирования",
    workbench: "Рабочее место",
    demand: "Спрос",
    forecasts: "Прогнозы",
    mps: "Главный график",
    orders: "Плановые заказы",
    schedule: "График",
    capacity: "Мощности",
    parameters: "Параметры",
    calendars: "Календари",
    setupMatrix: "Матрица переналадок",
    settings: "Настройки",
    sectionAria: "Страницы раздела",
    pool: "Пул спроса",
    board: "Доска",
    general: "Общие",
    promises: "Обещания",
    whatIf: "Что если",
  },
  common: {
    loading: "Загрузка планирования…",
    retry: "Повторить",
    requestId: "ID запроса",
    save: "Сохранить",
    saving: "Сохранение…",
    cancel: "Отмена",
    close: "Закрыть",
    edit: "Изменить",
    view: "Открыть",
    yes: "Да",
    no: "Нет",
    all: "Все",
    clearFilters: "Сбросить фильтры",
    filters: "Фильтры",
    filtersCount: "Фильтры ({{count}})",
    done: "Готово",
    removeFilter: "Убрать {{filter}}",
    previous: "Назад",
    next: "Далее",
    rowsRange: "{{from}}–{{to}} из {{total}}",
    page: "Страница {{page}}",
    daysCount: "{{count}} дн.",
    offlineWrites: "Нет сети. Изменения можно будет сохранить, когда связь вернётся.",
    changedBySomeone:
      "Кто-то сохранил раньше вас. Показаны последние значения: проверьте их и сохраните снова.",
    saveFailed: "Изменение не сохранено. ID запроса: {{requestId}}",
    saveFailedShort: "Изменение не сохранено. Попробуйте ещё раз.",
  },
  access: {
    title: "Планирование вам недоступно",
    area: "В вашей роли нет планирования. Обратитесь к администратору группы, если оно нужно.",
    screen:
      "Этот раздел планирования не входит в вашу роль. Откройте другой раздел или обратитесь к администратору группы.",
  },
  facility: {
    label: "Площадка",
    error: "Не удалось загрузить площадки.",
    noneTitle: "Нет площадки для планирования",
    noneBody:
      "Ваш доступ не охватывает ни одной действующей площадки. Попросите администратора группы добавить вас.",
  },
  status: {
    active: "Действует",
    archived: "В архиве",
  },
  forecastStatus: {
    draft: "Черновик",
    active: "Действует",
    archived: "В архиве",
  },
  settings: {
    title: "Настройки планирования",
    loading: "Загрузка настроек…",
    loadError: "Не удалось загрузить настройки планирования.",
    readOnly: "Вы можете просматривать эти настройки. Меняет их администратор площадки или группы.",
    defaults: "Площадка работает на настройках по умолчанию. Сохранение создаст собственные.",
    saved: "Настройки сохранены.",
    barsGroupAdmin: "Оба порога утверждения задаёт только администратор группы.",
    mpsTitle: "Утверждение графика производства",
    mpsBody:
      "Ниже первого порога изменённый график утверждается автоматически, до второго — администратором площадки, выше — администратором группы.",
    horizonTitle: "Горизонт планирования",
    horizonHint: "Недели, которые охватывают пул спроса, график производства и редактор прогноза.",
    weeks: "нед.",
    days: "дн.",
    minutes: "мин.",
    debounceHint:
      "После изменения заказа пул спроса обновляется через столько минут, сколько бы изменений ни пришло за это время.",
    nightlyOn: "Ночной запуск последний раз взят за {{date}}.",
    nightlyNever: "Ночной запуск последний раз взят: ни разу.",
    weeklyOn: "Недельное предложение последний раз взято за {{date}}.",
    weeklyNever: "Недельное предложение последний раз взято: ни разу.",
    fields: {
      mps_auto_approve_delta_pct: "Утверждать автоматически до",
      mps_facility_admin_delta_pct: "Администратор площадки утверждает до",
      horizon_weeks: "Горизонт",
      demand_refresh_debounce_minutes: "Обновлять спрос после изменения через",
      facility_shift_pattern_id: "Календарь площадки",
      mrp_release_buffer_days: "Запас на выдачу",
      mrp_qty_tolerance_pct: "Допуск по количеству",
      schedule_horizon_days: "Горизонт расписания",
      schedule_batching_window_hours: "Объединять в партию заказы со сроком позже до",
      schedule_solve_debounce_minutes: "Пересчитывать после изменения через",
      schedule_frozen_hours: "Сохранять опубликованную очерёдность на ближайшие",
      overtime_cost_pct: "Сверхурочные по ставке",
      schedule_auto_publish:
        "Публиковать пересчёт самостоятельно, если ничего не сдвинулось слишком далеко",
    },
    calendarTitle: "Календарь площадки",
    calendarHint:
      "По этому сменному графику MRP считает сроки поставки, запас на запуск и сроки готовности. Графики ведутся в разделе «Календари».",
    noCalendar: "Без календаря",
    calendarSet:
      "У площадки есть календарь. Какой именно график, видят планировщики и администраторы.",
    calendarUnset: "У площадки пока нет календаря, поэтому MRP не может планировать её даты.",
    patternsLoading: "Загрузка сменных графиков…",
    patternsError: "Не удалось загрузить сменные графики, поэтому календарь здесь изменить нельзя.",
    archivedPattern: "{{name}} (в архиве)",
    mrpTitle: "MRP",
    mrpBody: "Как MRP рассчитывает сроки и размеры плановых заказов.",
    workingDays: "раб. дн.",
    bufferHint: "Рабочие дни между выдачей заказа и его запуском.",
    toleranceHint:
      "Утверждённый заказ, количество которого отличается от потребности не больше чем на эту долю, не получает сообщения о количестве.",
    nightlyMrpOn: "Ночной MRP последний раз взят за {{date}}.",
    nightlyMrpNever: "Ночной MRP последний раз взят: ни разу.",
    scheduleTitle: "Расписание",
    scheduleBody:
      "На какой срок вперёд строится расписание с учётом мощностей, как оно собирает партии и когда пересчёт попадает в цех без участия человека.",
    hours: "ч",
    scheduleHorizonHint: "Сколько дней от сегодняшнего расписание заполняет работой, от 7 до 84.",
    frozenHint:
      "Работа, которую опубликованное расписание начинает в ближайшие столько часов, сохраняет своё место при каждом пересчёте. 0 отключает это.",
    batchingHint:
      "Заказ со сроком позже на столько может быть подтянут вперёд, чтобы пройти без переналадки.",
    overtimeCostHint:
      "Сверхурочная работа оценивается по этой доле ставки труда, от 100 до 300. Изменение пересчитывает расписание.",
    solveDebounceHint:
      "После изменения расписание пересчитывается через столько минут, сколько бы изменений ни пришло за это время.",
    autoPublishHint:
      "Включено: черновик без сдвигов сверх допуска и без новых перегрузок публикуется сам. Выключено: каждый черновик публикует человек.",
    nightlyScheduleOn: "Ночное расписание последний раз взято за {{date}}.",
    nightlyScheduleNever: "Ночное расписание последний раз взято: ни разу.",
    errors: {
      pct: "Введите процент, не более двух знаков после запятой.",
      pctMax: "Введите процент от 0 до 100.",
      horizon: "Введите целое число недель от 1 до 52.",
      debounce: "Введите целое число минут от 1 до 60.",
      days: "Введите целое число дней, 0 или больше.",
      barOrder:
        "Порог автоматического утверждения не может быть выше порога администратора площадки.",
      barsLineage: "Этот порог меняет только администратор группы.",
      pattern: "Этого сменного графика больше нет или он в архиве. Выберите другой.",
      buffer: "Введите целое число рабочих дней от 0 до 10.",
      scheduleHorizon: "Введите целое число дней от 7 до 84.",
      batching: "Введите целое число часов от 1 до 336.",
      frozen: "Введите целое число часов от 0 до 72.",
      overtime: "Введите целое число процентов от 100 до 300.",
    },
  },
  calendars: {
    title: "Календари",
    loading: "Загрузка календарей…",
    readOnly: "Вы можете просматривать календари. Меняет их администратор площадки или группы.",
    phoneReadOnly: "На телефоне календари только для просмотра. Меняйте их на компьютере.",
    saved: {
      patternCreated: "Сменный график {{code}} добавлен.",
      patternUpdated: "Сменный график {{code}} сохранён.",
      patternArchived: "Сменный график {{code}} перенесён в архив.",
      patternRestored: "Сменный график {{code}} восстановлен.",
      assigned: "График {{pattern}} назначен участку {{workCenter}}.",
      ended: "Назначение участка {{workCenter}} теперь заканчивается {{date}}.",
      reopened: "Назначение участка {{workCenter}} теперь без даты окончания.",
      removed: "Будущее назначение участка {{workCenter}} удалено.",
      exceptionAdded: "Добавлено: {{kind}}.",
      exceptionRemoved: "Удалено: {{kind}}.",
      facilityCalendar: "Календарь площадки теперь «{{name}}».",
      facilityCalendarCleared: "Календарь площадки снят.",
    },
    facility: {
      title: "Календарь площадки",
      body: "По календарю площадки MRP считает сроки поставки, запас на запуск и сроки готовности: это сменный график и праздники, закрывающие всю площадку.",
      current: "Площадка планируется по графику «{{name}}».",
      none: "MRP не может планировать даты этой площадки, пока у неё нет календаря.",
      pattern: "График",
      noCalendar: "Без календаря",
      save: "Назначить календарь",
      changed:
        "Настройки планирования площадки уже сохранил кто-то другой. Показан текущий календарь; выберите ещё раз.",
      patternGone: "Этого сменного графика больше нет или он в архиве. Выберите другой.",
      noPatterns:
        "Сначала добавьте действующий сменный график, затем назначьте его календарём площадки.",
    },
    preview: {
      title: "Четыре недели вперёд",
      of: "Календарь",
      facilityScope: "Вся площадка",
      earlier: "Предыдущие недели",
      later: "Следующие недели",
      thisWeek: "Эта неделя",
      range: "С {{from}} по {{to}}, время площадки ({{zone}})",
      loading: "Загрузка календаря…",
      loadError: "Не удалось загрузить календарь.",
      label: "Рабочие дни с {{from}}",
      working: "Рабочий",
      closed: "Не работает",
      uncalendared: "Нет календаря",
      hours: "{{value}} ч",
      effective: "{{value}} ч с учётом выработки",
      atEfficiency: "выработка {{pct}} %",
      nextDay: "до следующего дня",
      extraShift: "Дополнительная смена",
      closedBy: "Закрыто: {{names}}",
      changedBy: "Изменено: {{names}}",
      uncalendaredWorkCenter:
        "У этого участка нет календаря на часть этих дат. На такие даты MRP берёт часы календаря площадки.",
    },
    patterns: {
      title: "Сменные графики",
      add: "Добавить график",
      loading: "Загрузка сменных графиков…",
      loadError: "Не удалось загрузить сменные графики.",
      emptyTitle: "Сменных графиков пока нет",
      emptyBody: "Добавьте смены, в которые работает площадка.",
      filteredEmptyTitle: "Здесь нет сменных графиков",
      filteredEmptyBody:
        "Нет графиков со статусом «{{status}}». Покажите все графики, чтобы увидеть остальные.",
      showAll: "Показать все графики",
      status: "Статус",
      columns: {
        code: "Код",
        name: "Название",
        segments: "Смены",
        status: "Статус",
        actions: "Действия",
      },
    },
    editor: {
      newTitle: "Новый сменный график",
      editTitle: "Сменный график {{code}}",
      code: "Код",
      codeHint:
        "Заглавные латинские буквы, цифры, _ и -, например 2SHIFT_12H. Позже код не меняется.",
      name: "Название",
      segmentsTitle: "Смены",
      segmentsHint:
        "Одна строка на смену и день. Смена, которая заканчивается раньше начала, идёт до следующего дня и относится к дню начала.",
      noSegments: "Смен пока нет. Добавьте смены этого графика.",
      weekday: "День",
      start: "Начало",
      end: "Конец",
      shiftCode: "Код смены",
      efficiency: "Выработка, %",
      removeSegment: "Удалить смену {{n}}",
      remove: "Удалить",
      crosses: "До следующего дня",
      quickTitle: "Добавить одну смену на несколько дней",
      days: "Дни",
      addSegments: "Добавить смены",
      quickHint: "Отметьте дни, заполните смену один раз и добавьте её на все отмеченные дни.",
      archive: "В архив",
      restore: "Восстановить",
      archivedNote: "График в архиве. Восстановите его, чтобы снова назначать.",
      dirtyArchive: "Сохраните или отмените изменения, прежде чем отправлять график в архив.",
      readOnly:
        "Вы можете просматривать этот график. Меняет его администратор площадки или группы.",
      errors: {
        code: "Используйте от 1 до 64 заглавных латинских букв, цифр, _ или -, первым символом букву или цифру.",
        codeTaken: "Этот код уже занят другим графиком.",
        name: "Введите название от 1 до 120 символов.",
        changed:
          "Этот график уже сохранил кто-то другой. Показана последняя версия; проверьте её и сохраните снова.",
        outOfScope:
          "График используется на площадках вне вашего доступа: {{facilities}}. Изменить его может администратор группы.",
        inUse:
          "График используется в назначениях участков ({{assignments}}) и календарях площадок ({{facilities}}). Завершите эти назначения и выберите другой календарь площадки, прежде чем отправлять его в архив.",
        gone: "Этого графика больше нет. Закройте редактор и обновите список.",
        segments: {
          no_segments: "Добавьте хотя бы одну смену.",
          too_many_segments: "В графике не больше 42 смен.",
          weekday_out_of_range: "Выберите день с понедельника по воскресенье.",
          start_malformed: "Введите начало в виде ЧЧ:ММ.",
          end_malformed: "Введите конец в виде ЧЧ:ММ.",
          shift_code_missing: "Введите код смены.",
          shift_code_too_long: "Код смены не длиннее 32 символов.",
          efficiency_out_of_range: "Выработка — целое число от 10 до 200.",
          zero_length:
            "Начало и конец совпадают. Запишите суточную смену как две смены, идущие одна за другой.",
          overlaps: "Пересекается со сменой {{other}}.",
        },
      },
    },
    assignments: {
      title: "Календари участков",
      add: "Назначить график",
      loading: "Загрузка календарей участков…",
      loadError: "Не удалось загрузить календари участков.",
      emptyTitle: "Ни у одного участка пока нет календаря",
      emptyBody:
        "Назначьте сменный график каждому участку. До этого MRP планирует участок по часам календаря площадки.",
      filteredEmptyBody: "У участка {{workCenter}} пока нет календаря. Назначьте ему график.",
      filter: "Участок",
      allWorkCenters: "Все участки",
      columns: {
        workCenter: "Участок",
        pattern: "График",
        from: "С",
        to: "По",
        state: "Состояние",
        warning: "Сверка смен",
        actions: "Действия",
      },
      openEnded: "Без окончания",
      inEffect: "Действует",
      future: "Начнётся позже",
      ended: "Завершено",
      shiftsOk: "Совпадает со сменами производства",
      missingCodes: "Нет смены производства {{codes}}",
      missingCodesHint:
        "В производстве нет действующей смены с этими кодами на площадке. Планирование всё равно использует график; производство учитывает работу по своим сменам.",
      end: "Изменить окончание",
      remove: "Удалить",
      dialog: {
        title: "Назначить сменный график",
        workCenter: "Участок",
        pattern: "График",
        validFrom: "Первый день",
        validTo: "Последний день",
        validToHint: "Оставьте пустым, если окончания нет.",
        save: "Назначить",
        choose: "Выберите…",
      },
      endDialog: {
        title: "Окончание назначения участка {{workCenter}}",
        validTo: "Последний день",
        openEnded: "Без даты окончания",
        save: "Сохранить",
      },
      errors: {
        required: "Выберите участок, график и первый день.",
        reversed: "Последний день не может быть раньше первого.",
        overlap: "Пересекается с назначением с {{from}} по {{to}}.",
        overlapOpen: "Пересекается с назначением с {{from}} без даты окончания.",
        overlapUnknown: "Пересекается с другим назначением этого участка.",
        workCenterGone: "Этот участок больше не действует на площадке.",
        patternGone: "Этого сменного графика больше нет или он в архиве.",
        patternArchived:
          "Сменный график этого назначения в архиве, поэтому оно не может действовать после сегодняшнего дня. Восстановите график или назначьте другой.",
        inEffect: "Назначение уже действует. Измените его окончание.",
        gone: "Этого назначения больше нет. Список обновлён.",
      },
    },
    exceptions: {
      title: "Праздники, простои и дополнительные смены",
      add: "Добавить исключение",
      loading: "Загрузка исключений…",
      loadError: "Не удалось загрузить исключения.",
      emptyTitle: "В эти даты исключений нет",
      emptyBody:
        "Добавьте праздник, плановый ремонт, поломку, сверхурочную работу или дополнительную смену, когда меняются часы работы.",
      filteredEmptyBody:
        "В эти даты ничего не подходит под отбор: {{filters}}. Снимите отбор, чтобы увидеть все исключения.",
      from: "С",
      to: "По",
      kind: "Вид",
      allKinds: "Все виды",
      scope: "Действует для",
      wholeFacility: "Вся площадка",
      allScopes: "Площадка и все участки",
      columns: {
        kind: "Вид",
        scope: "Действует для",
        starts: "Начало",
        ends: "Конец",
        factor: "Мощность",
        note: "Примечание",
        actions: "Действия",
      },
      closed: "Закрыто",
      factor: "× {{factor}} мощности",
      allDayRange: "Целые дни",
      remove: "Удалить",
      kinds: {
        holiday: "Праздник",
        planned_maintenance: "Плановый ремонт",
        breakdown: "Поломка",
        extra_shift: "Дополнительная смена",
        overtime: "Сверхурочная работа",
      },
      window: {
        malformed: "Введите обе даты.",
        reversed: "Последняя дата раньше первой.",
        too_wide: "Выберите не более 731 дня.",
      },
      dialog: {
        title: "Добавить исключение",
        scope: "Действует для",
        kind: "Вид",
        allDay: "Целые дни",
        startDate: "Первый день",
        startTime: "Начало в",
        endDate: "Последний день",
        endTime: "Конец в",
        factor: "Коэффициент мощности",
        factorHint:
          "0 закрывает. 1 — обычная мощность. Выше 1, до 3, можно только для сверхурочной работы и дополнительных смен.",
        note: "Примечание",
        save: "Добавить",
      },
      errors: {
        starts_malformed: "Укажите, когда начинается.",
        ends_malformed: "Укажите, когда заканчивается.",
        ends_not_after_starts: "Конец должен быть позже начала.",
        factor_malformed: "Введите число, не более двух знаков после запятой.",
        factor_out_of_range: "Коэффициент мощности не больше 3.",
        factor_above_one_for_kind:
          "Поднять мощность выше 1 можно только сверхурочной работой и дополнительной сменой.",
        note_too_long: "Примечание не длиннее 500 символов.",
        kind_unknown: "Выберите вид.",
        starts_at_malformed: "Укажите, когда начинается.",
        ends_at_malformed: "Укажите, когда заканчивается.",
        workCenterGone: "Этот участок больше не действует на площадке.",
        gone: "Этого исключения больше нет. Список обновлён.",
      },
    },
  },
  workbench: {
    title: "Рабочее место планировщика",
    loading: "Загрузка истории обновлений…",
    loadError: "Не удалось загрузить рабочее место.",
    emptyTitle: "Спрос ещё не обновлялся",
    emptyBody: "Запустите обновление или дождитесь запуска в 02:00.",
    last: "Последнее обновление {{time}}",
    rerun: "Запустить снова",
    pending: "Обновление в очереди после изменений: {{count}}, запуск в {{time}}.",
    pending_one: "Обновление в очереди после изменений: {{count}}, запуск в {{time}}.",
    retrying: "Неудачных попыток: {{count}}. Следующая попытка в {{time}}.",
    failures:
      "Неудачных обновлений подряд: {{count}}. Показан пул последнего успешного обновления.",
    historyTitle: "История обновлений",
    duration: "{{minutes}} мин {{seconds}} с",
    durationSeconds: "{{seconds}} с",
    durationUnderSecond: "Меньше 1 с",
    deferredTitle: "Строки, ждущие решения по кредиту",
    deferredBody:
      "Строк заказов вне пула из-за кредитной блокировки: {{count}}. Они вернутся при следующем обновлении после её снятия.",
    deferredBody_one:
      "Строк заказов вне пула из-за кредитной блокировки: {{count}}. Она вернётся при следующем обновлении после её снятия.",
    skippedTitle: "Пропущенные строки",
    skippedBody:
      "Строк пропущено, так как их единицу нельзя пересчитать в базовую единицу продукта: {{count}}. Исправьте единицу в заказе или в продукте.",
    skippedBody_one:
      "Строк пропущено, так как её единицу нельзя пересчитать в базовую единицу продукта: {{count}}. Исправьте единицу в заказе или в продукте.",
    shipmentLine: "Строка отгрузки для расчёта среднего спроса",
    uomNotConvertible: "единица не пересчитывается",
    columns: {
      started: "Начато",
      trigger: "Запуск",
      status: "Статус",
      duration: "Длительность",
      orderLines: "Строки заказов",
      orderLine: "Строка заказа",
      why: "Причина",
      entries: "Записи",
      deferred: "Ждут кредита",
      skipped: "Пропущено",
      error: "Ошибка",
    },
    tiles: {
      openDemand: "Открытый спрос",
      orderLines: "Строки заказов",
      deferred: "Ждут кредита",
      deferredSub: "строк заказов вне пула",
      skipped: "Пропущено",
      skippedSub: "единица не пересчитывается",
      noRefresh: "Успешных обновлений ещё нет",
      asOf: "По последнему успешному обновлению",
      partial: "Строк, у которых ещё загружается продукт: {{count}}",
      mps: "Главный график",
      mpsNone: "Плана пока нет",
      mpsError: "Не удалось прочитать план",
      mpsProposed: "предложен {{time}}",
    },
  },
  demand: {
    title: "Пул спроса",
    loading: "Загрузка пула спроса…",
    loadError: "Не удалось загрузить пул спроса.",
    refresh: "Обновить спрос",
    refreshing: "Обновление…",
    refreshDone: "Спрос обновлён в {{time}}.",
    refreshFailed: "Обновление не удалось: {{error}}. Действует предыдущий пул.",
    refreshRequestFailed: "Не удалось запустить обновление. ID запроса: {{requestId}}",
    noRefreshTitle: "Спрос здесь ещё не обновлялся",
    noRefreshBody: "Запустите обновление или дождитесь следующего запуска.",
    emptyTitle: "Пул спроса пуст",
    emptyBody: "Подтвердите заказы клиентов или активируйте прогноз.",
    filteredEmptyTitle: "Нет спроса по этим фильтрам",
    filteredEmptyBody: "Действуют фильтры: {{filters}}.",
    replaced: "Более новое обновление заменило просматриваемый пул, поэтому показан последний.",
    shown: "Пул обновления, завершённого {{time}}",
    transferOrder: "Перемещение {{number}} на {{facility}}",
    transferTo: "Перемещение на {{facility}}",
    salesOrder: "Заказ клиента",
    lineNo: "строка {{line}}",
    subtotalsTitle: "Чистый спрос по продуктам и неделям",
    entriesTitle: "Записи спроса",
    drillHint: "Откройте строку прогноза, чтобы увидеть, какие заказы его поглотили.",
    views: {
      label: "Вид пула спроса",
      entries: "Записи",
      totals: "Итоги по неделям",
    },
    filterChip: "{{filter}}: {{value}}",
    filters: {
      product: "Продукт",
      source: "Источник",
      basis: "Дата",
      from: "С недели",
      to: "По неделю",
      plannerCode: "Код планировщика",
    },
    columns: {
      product: "Продукт",
      source: "Источник",
      basis: "Дата",
      bucket: "Неделя",
      due: "Срок",
      original: "Количество",
      consumed: "Поглощено",
      net: "Чистый",
      total: "Итого",
    },
    source: {
      sales_order: "Заказ",
      forecast: "Прогноз",
      safety_stock: "Страховой запас",
      transfer: "Перемещение",
    },
    basis: {
      line_promise: "Обещанная дата",
      undated: "Без обещанной даты, на эту неделю",
      past_due: "Просрочено",
    },
    trigger: {
      cron: "Ночной",
      manual: "Вручную",
      event: "После изменений",
      mrp: "По MRP",
    },
    status: {
      running: "Идёт",
      succeeded: "Готово",
      failed: "Ошибка",
    },
    consumption: {
      title: "{{product}}, {{week}}: поглощено заказами",
      loading: "Загрузка поглощения…",
      loadError: "Не удалось загрузить поглощение.",
      none: "У этого прогноза нет строки на эту неделю в показанном обновлении.",
      noOrders: "Ни один заказ не поглотил прогноз этой недели.",
      summary: "Прогноз {{original}}, поглощено {{consumed}}, чистый {{net}}.",
    },
  },
  parameters: {
    title: "Параметры планирования",
    loading: "Загрузка параметров планирования…",
    loadError: "Не удалось загрузить параметры планирования.",
    readOnly:
      "Вы можете просматривать параметры. Меняют их планировщик, администратор площадки или группы.",
    emptyTitle: "Параметров планирования пока нет",
    emptyBody: "Добавьте изделия, которые планирует эта площадка.",
    filteredEmptyTitle: "Нет изделий по этим фильтрам",
    filteredEmptyBody: "Действующие фильтры: {{filters}}.",
    addProduct: "Добавить изделие",
    sectionTitle: "Параметры",
    drawerLabel: "Планирование: {{product}}",
    save: "Сохранить параметры",
    archive: "В архив",
    restore: "Восстановить",
    archiveConfirmTitle: "Перенести параметры в архив",
    archiveConfirm:
      "Перенести параметры изделия в архив? Изделие перестанет планироваться на этой площадке, пока его не восстановят.",
    archiveConfirmPolicy:
      "Перенести параметры изделия в архив? Его страховой запас ({{policy}}) уйдёт в архив вместе с ними, и изделие перестанет планироваться на этой площадке, пока его не восстановят.",
    archivedRow: "Эти параметры в архиве. Восстановите их, чтобы снова планировать изделие.",
    savedNotice: "Параметры сохранены.",
    archivedNotice: "Параметры перенесены в архив.",
    restoredNotice: "Параметры восстановлены.",
    chooseSource: "Выберите площадку",
    otherFacility: "другая площадка",
    transferFrom: "Перемещение с площадки {{facility}}",
    mpsYes: "В графике производства",
    mpsNo: "Вне графика производства",
    columns: {
      product: "Изделие",
      replenishment: "Пополнение",
      mps: "График производства",
      leadTime: "Срок поставки",
      lotSizing: "Размер партии",
      fence: "Зона заморозки",
      tolerance: "Допуск переноса",
      plannerCode: "Код планировщика",
      safetyStock: "Страховой запас",
      status: "Статус",
      actions: "Действия",
    },
    filters: {
      status: "Статус",
      replenishment: "Пополнение",
      mps: "График производства",
    },
    fields: {
      replenishment: "Пополнение",
      source: "Площадка-источник",
      mps: "В графике производства",
      leadTime: "Срок поставки, дн.",
      lotSizing: "Размер партии",
      minLot: "Минимальная партия",
      multiple: "Кратность партии",
      fence: "Зона заморозки, дн.",
      tolerance: "Допуск переноса, дн.",
      plannerCode: "Код планировщика",
    },
    replenishment: {
      make: "Производство",
      buy: "Закупка",
      transfer: "Перемещение",
    },
    lot: {
      lot_for_lot: "Партия под потребность",
      min_multiple: "Минимум и кратность",
      minMultipleShort: "Мин. {{min}}, кратн. {{multiple}}",
    },
    errors: {
      wholeDays: "Введите целое число дней, 0 или больше.",
      positiveQty: "Введите количество больше нуля, не более трёх знаков после запятой.",
      plannerCode: "Код планировщика не длиннее 64 символов.",
    },
    reasons: {
      METHOD_FIELDS_MISMATCH:
        "Для метода «минимум и кратность» нужна минимальная партия. «Партия под потребность» не принимает количеств.",
      TRANSFER_SOURCE_REQUIRED: "Для перемещения нужна площадка, откуда оно идёт.",
      SOURCE_NOT_ALLOWED: "Площадку-источник указывают только для перемещения.",
      SOURCE_FACILITY_INVALID: "Выберите источником другую действующую площадку группы.",
      PRODUCT_ARCHIVED: "Изделие в архиве каталога.",
      PRODUCT_NOT_FOUND: "Изделия больше нет в каталоге.",
    },
    problems: {
      PRODUCT_ARCHIVED: "Это изделие в архиве каталога, поэтому его нельзя планировать.",
      PRODUCT_NOT_FOUND: "Этого изделия больше нет в каталоге.",
    },
  },
  safety: {
    title: "Страховой запас",
    current: "Текущее правило: {{policy}}",
    none: "Нет",
    staticShort: "Держать {{qty}}",
    daysShort: "Покрытие: {{count}} дн.",
    needsParameters:
      "Сначала сохраните действующие параметры. Страховой запас задаётся для планируемого изделия.",
    method: "Метод",
    methods: {
      static_qty: "Фиксированное количество",
      days_of_cover: "Дни покрытия",
    },
    staticQty: "Количество в запасе",
    daysOfCover: "Дни покрытия",
    validFrom: "Действует с",
    validFromHint: "Оставьте пустым, чтобы начать с сегодняшнего дня.",
    validTo: "Действует по",
    save: "Сохранить страховой запас",
    remove: "Убрать страховой запас",
    savedNotice: "Страховой запас сохранён.",
    removedNotice: "Страховой запас убран.",
    errors: {
      qty: "Введите количество, 0 или больше, не более трёх знаков после запятой.",
      days: "Введите целое число дней, 1 или больше.",
      invalid: "Проверьте значения и сохраните снова.",
    },
    reasons: {
      METHOD_FIELDS_MISMATCH: "Для этого метода нужно его собственное значение и никакое другое.",
      VALID_RANGE_INVALID: "Дата окончания не может быть раньше даты начала.",
      NO_PLANNING_PARAMETERS: "Сначала сохраните действующие параметры этого изделия.",
    },
  },
  bulk: {
    selectAll: "Выбрать все строки на странице",
    selectRow: "Выбрать {{product}}",
    count: "Выбрано: {{count}}",
    clear: "Снять выбор",
    field: "Поле",
    value: "Значение",
    apply: "Применить к выбранным ({{count}})",
    applying: "Применение…",
    saved: "Сохранено: {{count}}",
    changed: "Изменено другим пользователем: {{count}}",
    failed: "Не сохранено: {{count}}",
    refused: "Отклонено, {{reason}}: {{count}}",
    row: {
      changed: "другой пользователь сохранил эту строку раньше",
      failed: "её не удалось сохранить",
    },
  },
  forecasts: {
    title: "Прогнозы",
    loading: "Загрузка прогнозов…",
    loadError: "Не удалось загрузить прогнозы.",
    emptyTitle: "Прогнозов пока нет",
    emptyBody: "Создайте прогноз спроса, который вы ожидаете до прихода заказов.",
    filteredEmptyTitle: "Нет прогнозов с этим статусом",
    filteredEmptyBody: "Показан статус: {{status}}.",
    filterStatus: "Статус",
    new: "Новый прогноз",
    create: "Создать",
    windowDays: "± {{count}} дн.",
    windowHint:
      "Заказы в пределах стольких дней до и после недели погашают её прогноз. От 0 до 91.",
    columns: {
      name: "Название",
      status: "Статус",
      mode: "Режим",
      window: "Окно погашения",
      lines: "Строки",
      updated: "Изменён",
    },
    fields: {
      name: "Название",
      mode: "Режим",
      window: "Окно погашения, дн.",
    },
    modes: {
      consume: "Погашается заказами",
      additive: "Добавляется к заказам",
    },
    modeHints: {
      consume: "Заказы расходуют прогноз, поэтому спрос равен большему из двух.",
      additive: "Прогноз и заказы складываются: для спроса, который не покроет ни один заказ.",
    },
    errors: {
      name: "Дайте прогнозу название длиной до 120 символов.",
      nameTaken: "На этой площадке уже есть прогноз с таким названием.",
      window: "Введите целое число дней от 0 до 91.",
    },
  },
  editor: {
    title: "Прогноз",
    loading: "Загрузка прогноза…",
    loadError: "Не удалось загрузить прогноз.",
    notFound: "Такого прогноза нет, или он относится к площадке вне вашего доступа.",
    empty: "В эти недели строк нет. Добавьте изделие, чтобы начать.",
    outside: "Строк вне этих недель: {{count}}",
    archivedBanner: "Прогноз в архиве. Его больше нельзя изменить или сделать действующим.",
    phoneReadOnly:
      "На телефоне прогноз доступен только для чтения. Откройте его на широком экране, чтобы изменить.",
    saveDetails: "Сохранить сведения",
    activate: "Ввести в действие",
    archive: "В архив",
    archiveConfirm:
      "Перенести прогноз в архив? Архивный прогноз уже нельзя будет изменить или снова сделать действующим.",
    detailsSavedNotice: "Сведения сохранены.",
    activatedNotice: "Прогноз действует.",
    archivedNotice: "Прогноз перенесён в архив.",
    transitionInvalid: "Прогноз нельзя перевести в этот статус из текущего.",
    headerInvalid: "Проверьте название и окно, затем сохраните снова.",
    earlier: "Раньше",
    later: "Позже",
    windowRange: "С {{from}} по {{to}}",
    saveBeforeMoving: "Сохраните или отмените изменения, чтобы перейти к другим неделям.",
    addProduct: "Добавить изделие",
    pasteHint:
      "Вставьте блок из таблицы. Первая строка с датами задаёт недели, первый столбец с артикулами — изделия.",
    note: "Примечание: {{product}}, {{week}}",
    noteNeedsQty: "Сначала введите количество на эту неделю, затем примечание.",
    save: "Сохранить изменения, изделий: {{count}}",
    discard: "Отменить изменения",
    changedUnderneath:
      "Другой пользователь изменил сохранённое значение этой недели. Проверьте его и сохраните снова.",
    leaveTitle: "Несохранённые изменения",
    leaveBody: "Изделий с несохранёнными изменениями: {{count}}. Уйти и потерять их?",
    leave: "Уйти без сохранения",
    stay: "Остаться",
    report: {
      saved: "Сохранено, изделий: {{count}} ({{products}}).",
      refused:
        "Не сохранено, изделий: {{count}} ({{products}}). Отмеченные ячейки объясняют причину.",
      changed:
        "Другой пользователь сохранил прогноз раньше. Показаны последние строки, ваши изменения сохранены в сетке.",
      archived: "Прогноз перенесён в архив, поэтому больше ничего не сохранено.",
      weekRolled:
        "Началась новая неделя, и прошлая неделя теперь только для чтения. Остальные изменения сохранены в сетке, сохраните ещё раз.",
      pastDropped: "Началась новая неделя, поэтому изменения прошлой недели не сохранены.",
    },
    rowCodes: {
      BUCKET_NOT_MONDAY: "Неделя должна начинаться с понедельника",
      BUCKET_OUTSIDE_WINDOW: "Эта неделя вне показанных недель",
      DUPLICATE_LINE: "Это изделие и неделя указаны дважды",
      PRODUCT_NOT_FOUND: "Этого изделия больше нет",
      PRODUCT_ARCHIVED: "Изделие в архиве каталога",
      PRODUCT_OUTSIDE_SCOPE: "Это изделие не входило в сохранение",
      QTY_NEGATIVE: "Количество не может быть отрицательным",
      QTY_PRECISION: "Не более трёх знаков после запятой",
      QTY_TOO_LARGE: "Слишком большое количество",
      NOTE_TOO_LONG: "Примечание длиннее 500 символов",
    },
  },
  paste: {
    summary: "Вставлено значений: {{count}}. Сохраните, чтобы их оставить.",
    snapped: "{{text}} не понедельник, поэтому значения попали в неделю с {{week}}.",
    problems: {
      not_number: "Строка {{line}}, столбец {{column}}: {{text}} не число.",
      precision:
        "Строка {{line}}, столбец {{column}}: в {{text}} больше трёх знаков после запятой.",
      week_outside:
        "Строка {{line}}, столбец {{column}}: эта неделя вне недель, которые здесь можно менять.",
      unknown_product: "Строка {{line}}: {{text}} не изделие этой сетки.",
      lookup_failed: "Строка {{line}}: {{text}} не удалось найти из-за ошибки. Вставьте ещё раз.",
      over_key_limit:
        "Строка {{line}}: {{text}} сверх 200 изделий, которые ищет одна вставка. Вставьте её отдельно.",
    },
  },
  picker: {
    placeholder: "Артикул или название",
    results: "Подходящие изделия",
    searching: "Поиск…",
    error: "Не удалось выполнить поиск изделий.",
    none: "Нет подходящих изделий.",
  },
  mps: {
    title: "Главный график производства",
    loading: "Загрузка графика производства…",
    loadError: "Не удалось загрузить график производства.",
    status: {
      proposed: "Предложен",
      adjusting: "Корректируется",
      pending_approval: "Ждёт утверждения",
      approved: "Утверждён",
      superseded: "Заменён",
    },
    autoApproved: "Утверждён автоматически при отправке",
    proposedAt: "Предложен {{time}}",
    proposeNow: "Предложить сейчас",
    proposing: "Формируется…",
    submit: "Отправить на утверждение",
    submitting: "Отправка…",
    approve: "Утвердить",
    reject: "Отклонить",
    plans: "Планы",
    plansEmpty: "На этой площадке ещё нет планов.",
    previousPlan: "утверждённом плане",
    totals: "Итого по плану:",
    diff: "Показать изменение относительно утверждённого плана",
    diffLoading: "Загрузка утверждённого плана для сравнения…",
    editHint:
      "Дважды щёлкните ячейку или нажмите Enter, чтобы изменить её. Для каждого изменения нужна причина. Ячейки с замком находятся внутри замороженного горизонта.",
    noPlannerCode: "Без кода планировщика",
    plannerCode: "Планировщик {{code}}",
    loadMore: "Показать ещё изделия",
    loadingMore: "Загрузка изделий…",
    receiptsHint:
      "Поступления: выпущенные и выполняемые производственные заказы, перемещения в пути и закреплённые плановые заказы на {{time}}. «Предложить сейчас» считывает их заново.",
    transferNote:
      "{{facilities}} продаёт изделия, производимые здесь; MRP превращает её заказы в спрос на перемещение в этом графике.",
    demandChanged: "Спрос изменился после того, как план был предложен.",
    demandChangedCells:
      "Спрос изменился после формирования плана: ячеек, отличающихся от исходного спроса: {{count}}.",
    demandChangedCells_one:
      "Спрос изменился после формирования плана: ячеек, отличающихся от исходного спроса: {{count}}.",
    returned: "Возвращён: {{who}}, {{date}}: {{note}}",
    routed:
      "Передано групповому администратору. План меняет график на {{pct}} %, а это больше, чем может утвердить администратор площадки.",
    earlier: "Вы смотрите более ранний план. Он доступен только для чтения.",
    earlierSuperseded: "Этот план заменён более новым. Он доступен только для чтения.",
    backToCurrent: "Открыть текущий план",
    openReplacement: "Открыть план, который его заменил",
    reload: "Обновить",
    conflict: {
      changed: "План изменился. Обновите страницу.",
      superseded: "План заменён. Обновите страницу.",
    },
    threshold: {
      first: "Это первый главный график площадки, поэтому его утверждает групповой администратор.",
      delta: "Изменение относительно утверждённого плана: {{pct}} % в единице {{unit}}.",
      deltaNoUnit: "Изменение относительно утверждённого плана: {{pct}} %.",
      aboveBar:
        "Это больше предела администратора площадки ({{bar}} %), поэтому план утверждает групповой администратор.",
      withinBar: "Администратор площадки может его утвердить (предел {{bar}} %).",
      products: "Наибольшие изменения среди показанных изделий:",
    },
    sub: {
      demand: "Спрос",
      receipts: "Плановые поступления",
      projected: "Прогнозный остаток на начало недели",
      proposed: "Предложение системы",
    },
    receipt: {
      work_order: "Производственный заказ {{ref}}: {{qty}}",
      transfer: "Перемещение {{ref}}: {{qty}}",
      planned_order: "Закреплённый плановый заказ {{ref}}: {{qty}}",
      due: "срок {{date}}",
      noDue: "без срока, учтено в первой неделе",
      overdue: "срок был {{date}}, учтено в первой неделе",
      released:
        "{{qty}} замороженного объёма этой недели уже в закреплённых плановых заказах или производственных заказах, выпущенных под утверждённый план, поэтому учтено один раз",
      heldBy: {
        planned_order: "закреплённый плановый заказ {{ref}}: {{qty}}, срок {{date}}",
        work_order: "производственный заказ {{ref}}: {{qty}}, срок {{date}}",
      },
    },
    note: {
      overridden: "Изменил: {{who}}, {{time}}. Причина: {{reason}}",
      droppedChanged:
        "Спрос изменился, ручное изменение снято. Было {{qty}} в плане «{{plan}}». Причина: {{reason}}",
      droppedFrozen:
        "Неделя вошла в замороженный горизонт, ручное изменение снято. Было {{qty}} в плане «{{plan}}». Причина: {{reason}}",
    },
    columns: {
      plan: "План",
      current: "текущий",
      status: "Статус",
      proposed: "Предложен",
      delta: "Изменение",
    },
    approveTitle: "Утвердить план",
    approveBody: "Утвердить {{plan}}. Он заменит действующий утверждённый план площадки.",
    rejectTitle: "Отклонить план",
    rejectBody: "Вернуть {{plan}} планировщику. Укажите, что нужно изменить.",
    noteOptional: "Примечание (необязательно)",
    noteRequired: "Примечание",
    outcome: {
      proposed: "План {{plan}} предложен.",
      submitted: "План {{plan}} отправлен и ждёт утверждения.",
      autoApproved: "План {{plan}} утверждён автоматически при отправке.",
      approved: "План {{plan}} утверждён.",
      rejected: "План {{plan}} возвращён планировщику.",
    },
    errors: {
      pending: "Отправленный план ждёт утверждения. Сначала утвердите или отклоните его.",
      refreshMissing:
        "Для этой недели ещё нет обновления спроса. Обновите спрос и предложите план снова.",
      noRelevant:
        "На этой площадке нет изделий в главном графике. Отметьте изделия для главного графика в параметрах планирования.",
      proposeFailed: "Не удалось предложить план. ID запроса: {{requestId}}",
      submitFailed: "Не удалось отправить план. ID запроса: {{requestId}}",
      lineChanged: "Эту ячейку уже изменил кто-то другой. Показано последнее значение.",
      frozen: "Эта неделя внутри замороженного горизонта и не может меняться.",
      reasonRequired: "Укажите причину изменения.",
      invalid: "Введите количество 0 или больше, не более трёх знаков после запятой.",
    },
    empty: {
      noRefreshTitle: "Главного графика пока нет",
      noRefreshBody: "Предложения графика появятся автоматически после первого обновления спроса.",
      noProductsTitle: "Здесь нет изделий в главном графике",
      noProductsBody:
        "На этой площадке нет изделий в главном графике. Отметьте изделия для главного графика в параметрах планирования.",
      toParameters: "Открыть параметры планирования",
      notProposedTitle: "Первое предложение формируется",
      notProposedBody:
        "План будет предложен автоматически после следующего обновления спроса. «Предложить сейчас» сформирует его сразу.",
      noLinesTitle: "В этом плане нет изделий",
      noLinesBody: "Когда план формировался, ни одно изделие не входило в главный график.",
    },
  },
  orders: {
    title: "Плановые заказы",
    loading: "Загрузка плановых заказов…",
    loadError: "Не удалось загрузить плановые заказы.",
    emptyTitle: "Плановых заказов нет",
    emptyBody: "Утвердите главный график или запустите MRP.",
    filteredEmptyTitle: "Нет плановых заказов под эти фильтры",
    filteredEmptyBody: "Фильтры: {{filters}}. Сбросьте фильтры, чтобы увидеть все заказы.",
    noMessagesTitle: "Сообщений к действию нет",
    noMessagesBody:
      "Ни один закреплённый заказ этой площадки не требует изменений. MRP пришлёт сообщение, когда потребуется.",
    purchaseOnly:
      "Вам видны только заказы на закупку. Заказы на производство и перемещение планирует завод.",
    purchaseOnlyShort: "только закупка",
    tabs: {
      label: "Списки плановых заказов",
      all: "Все",
      messages: "Сообщения к действию",
    },
    columns: {
      poNo: "Номер",
      kind: "Вид",
      product: "Продукт",
      qty: "Количество",
      start: "Начало",
      due: "Срок",
      status: "Статус",
      flags: "Отметки",
      suggestion: "Предложение",
      document: "Документ",
    },
    document: {
      work_order: "Черновик производственного заказа",
      transfer_order: "Черновик перемещения",
      purchase_proposal: "Предложение на закупку",
    },
    kind: {
      manufacture: "Производство",
      purchase: "Закупка",
      transfer: "Перемещение",
    },
    status: {
      proposed: "Предложен",
      firmed: "Закреплён",
      converted: "Передан в работу",
      cancelled: "Отменён",
    },
    message: {
      reschedule_in: "Приблизить",
      reschedule_out: "Отодвинуть",
      increase_qty: "Увеличить",
      decrease_qty: "Уменьшить",
      cancel: "Отменить",
      expedite: "Ускорить",
    },
    suggest: {
      reschedule_in: "Перенести срок ближе, на {{value}}",
      reschedule_out: "Перенести срок дальше, на {{value}}",
      increase_qty: "Увеличить количество до {{value}}",
      decrease_qty: "Уменьшить количество до {{value}}",
      cancel: "Отменить заказ, он больше не нужен",
      expedite: "Выпустить сегодня, дата выпуска уже прошла",
    },
    reason: {
      no_need_in_horizon: "В горизонте планирования для этого заказа не осталось потребности.",
      release_in_past: "Дата выпуска уже позади.",
      need_earlier: "Покрываемая потребность теперь наступает раньше.",
      need_later: "Покрываемая потребность теперь наступает позже.",
      share_below_qty: "Нужно меньше, чем содержит заказ.",
      need_uncovered_inside_fence: "Потребность внутри замороженного периода не покрыта.",
    },
    cancelledKind: {
      regenerated_away: "Заменён следующим расчётом",
      manual: "Отменён вручную",
      action_message_cancel: "Отменён по сообщению к действию",
    },
    filters: {
      kind: "Вид",
      status: "Статус",
      message: "Сообщение к действию",
      from: "Срок с",
      to: "Срок по",
      product: "Продукт",
      planner: "Код планировщика",
      run: "Расчёт MRP",
      line: "Строка заказа клиента",
      entry: "Запись спроса",
    },
    filterTag: {
      run: "Расчёт {{run}}",
      product: "Один продукт",
      line: "По одной строке заказа",
      entry: "По одной записи спроса",
    },
    removeFilter: "Убрать фильтр «{{filter}}»",
    messageAny: "Любое сообщение",
    messageNone: "Без сообщения",
    late: "Опаздывает",
    exceedsMps: "Сверх графика",
    stalePin: "Устаревшая спецификация",
    firm: "Закрепить",
    convert: "Передать в работу",
    cancelOrder: "Отменить заказ",
    cancelOrders: "Отменить",
    accept: "Принять",
    dismiss: "Отклонить",
    cancelReason: "Причина отмены",
    dismissReason: "Причина отклонения",
    selectPage: "Выбрать заказы на этой странице",
    selectRow: "Выбрать {{number}}",
    selectedCount: "Выбрано: {{count}}",
    selectedCount_one: "Выбрано: {{count}}",
    clearSelection: "Снять выбор",
    selectMatching: "Выбрать все подходящие (не больше {{max}})",
    selecting: "Выбор…",
    overMax: "Подходящих заказов больше, чем берёт одно действие. Выбраны первые {{max}}.",
    bulk: {
      firmTitle: "Закрепить плановые заказы",
      firmBody:
        "Закрепить плановые заказы, всего {{count}}: {{kinds}}. Закреплённый заказ сохраняет количество и даты, а MRP присылает сообщение вместо изменения.",
      firmBody_one:
        "Закрепить плановые заказы, всего {{count}}: {{kinds}}. Закреплённый заказ сохраняет количество и даты, а MRP присылает сообщение вместо изменения.",
      firmConfirm: "Закрепить",
      cancelTitle: "Отменить закреплённые заказы",
      cancelBody:
        "Отменить закреплённые среди выбранных заказов, всего выбрано {{count}}: {{kinds}}. Каждый отменяется отдельно, с одной причиной.",
      cancelBody_one: "Отменить выбранные заказы, всего {{count}}: {{kinds}}.",
      cancelConfirm: "Отменить заказы",
      acceptTitle: "Принять сообщения к действию",
      acceptBody:
        "Принять сообщения «отодвинуть», всего заказов {{count}}: {{kinds}}. Каждый переносится на дату из сообщения.",
      acceptBody_one:
        "Принять сообщения «отодвинуть», всего заказов {{count}}: {{kinds}}. Заказ переносится на дату из сообщения.",
      acceptConfirm: "Принять",
      convertTitle: "Передать закреплённые заказы в работу",
      convertBody:
        "Передать в работу закреплённые из выбранных заказов ({{count}}: {{kinds}}) как черновики производственных заказов и перемещений. Отказ останавливает только этот заказ.",
      convertBody_one:
        "Передать в работу выбранные заказы, всего {{count}}: {{kinds}}. Заказ на производство становится черновиком производственного заказа, заказ на перемещение — черновиком перемещения.",
      convertConfirm: "Передать в работу",
      convertNotFirmed:
        "Не закреплены и не будут отправлены: {{count}}. Сначала закрепите заказ, затем передавайте его в работу.",
      convertNotFirmed_one:
        "Не закреплены и не будут отправлены: {{count}}. Сначала закрепите заказ, затем передавайте его в работу.",
      convertBuy:
        "Заказов на закупку среди них: {{count}}. Здесь их нельзя передать в работу, поэтому каждый будет отклонён и останется закреплённым.",
      convertBuy_one:
        "Заказов на закупку среди них: {{count}}. Здесь его нельзя передать в работу, поэтому он будет отклонён и останется закреплённым.",
      notFirmed:
        "Не закреплены и не будут отправлены: {{count}}. Предложенный заказ заменит следующий расчёт.",
      notFirmed_one:
        "Не закреплены и не будут отправлены: {{count}}. Предложенный заказ заменит следующий расчёт.",
      kindCount: {
        manufacture: "производство: {{count}}",
        purchase: "закупка: {{count}}",
        transfer: "перемещение: {{count}}",
      },
    },
    result: {
      firmTitle: "Итоги закрепления",
      cancelTitle: "Итоги отмены",
      acceptTitle: "Итоги принятия",
      convertTitle: "Итоги передачи в работу",
      summary: "Выполнено: {{done}}. Отказано или не отправлено: {{refused}}.",
      firmed: "Закреплён",
      accepted: "Принято",
      cancelled: "Отменён",
      converted: "Передан в работу",
      alreadyConverted: "Передан в работу раньше",
      notSent: "Не закреплён, не отправлен",
    },
    refusal: {
      PLANNED_ORDER_NOT_PROPOSED: "Уже не в статусе «предложен»",
      PLANNED_ORDER_NOT_FIRMED: "Не закреплён",
      PLANNED_ORDER_NOT_FOUND: "Этого заказа больше нет",
      NO_ACTION_MESSAGE: "Сообщение уже снято",
      ACTION_MESSAGE_CHANGED: "Сообщение изменилось после того, как вы его прочитали",
      ACTION_MESSAGE_NOT_BULK_ACCEPTABLE: "Это сообщение принимается по одному заказу",
      PERMISSION_DENIED: "У вас нет права менять этот заказ",
      PURCHASE_CONVERSION_UNAVAILABLE:
        "Заказ на закупку здесь нельзя превратить в заказ поставщику",
      PLANNED_ORDER_NO_ROUTING:
        "Для этого изделия нет действующего маршрута. Добавьте его в каталоге и передайте заказ снова.",
      PLANNED_ORDER_PIN_INVALID:
        "Зафиксированную спецификацию или маршрут больше нельзя использовать.",
      ORDER_LINE_NOT_FOUND: "Строки заказа клиента, под которую он запланирован, больше нет",
      ORDER_NOT_CONFIRMED: "Заказ клиента, под который он запланирован, не подтверждён",
      ORDER_TERMINAL: "Заказ клиента, под который он запланирован, отгружен, закрыт или отменён",
      ORDER_LINE_TERMINAL:
        "Строка заказа клиента, под которую он запланирован, готова, отгружена или отменена",
      ORDER_LINE_PRODUCT_MISMATCH:
        "Строка заказа клиента, под которую он запланирован, относится к другому изделию",
      TRANSFER_SOURCE_INACTIVE: "Площадка-источник в архиве",
      FACILITY_NOT_FOUND: "Площадки этого перемещения больше нет",
      PRODUCT_NOT_FOUND: "Изделия этого заказа больше нет",
      other: "Отказано ({{code}})",
    },
    pin: {
      bom_archived:
        "Зафиксированная спецификация в архиве. Отмените заказ, и следующий расчёт предложит его по действующей спецификации.",
      routing_archived:
        "Зафиксированный маршрут в архиве. Отмените заказ, и следующий расчёт предложит его по действующему маршруту.",
      routing_without_steps:
        "В зафиксированном маршруте нет операций. Добавьте их или отмените заказ.",
    },
    noRoutingOn: "Маршрут искали на {{date}}.",
    ref: {
      sales_order_line: "Строка заказа клиента",
      forecast_line: "Прогноз",
      safety_stock_policy: "Страховой запас",
      transfer_planned_order: "Перемещение на другую площадку",
      mps_line: "Ячейка главного графика",
      planned_order: "Родительский плановый заказ",
      work_order: "Производственный заказ",
      excess: "Остаток партии, потребности пока нет",
      parentOrder: "Родительский заказ {{number}}",
      transferOrder: "Перемещение {{number}} на площадку {{facility}}",
      transferOrderShort: "Перемещение {{number}}",
      mpsCell: "Ячейка графика {{number}}",
      workOrder: "Производственный заказ {{number}}",
    },
    drawer: {
      label: "Плановый заказ",
      loadingTitle: "Плановый заказ",
      loading: "Загрузка планового заказа…",
      loadError: "Не удалось загрузить плановый заказ.",
      gone: "Этот плановый заказ заменён при перерасчёте. Его номер больше не принадлежит ни одному заказу.",
      release: "Выпуск",
      source: "Площадка-источник",
      firmed: "Закреплён",
      cancelled: "Отменён",
      converted: "Передан в работу как",
      byAt: "{{who}}, {{time}}",
      stalePinProposed:
        "Спецификация или маршрут изменились после фиксации заказа. Следующий расчёт разузлует его заново.",
      stalePinFirmed:
        "Спецификация или маршрут изменились после фиксации. Закреплённый заказ сохраняет их; отмените его, и MRP предложит заказ по новой версии.",
      exceedsMps: "Этот заказ планирует больше, чем утверждено в ячейке главного графика.",
      demand: "Потребность",
      noDemand: "Этот заказ ничем не вызван, он содержит только остаток партии.",
      neededBy: "нужно к {{date}}",
      chainUp: "Вверх по цепочке",
      walkHidden: "Не показано звеньев: {{count}}.",
      walkHidden_one: "Не показано звеньев: {{count}}.",
      qtyMath: "Расчёт количества",
      dateMath: "Расчёт дат",
      drives: "Вызывает",
      drivesNone: "Ни один другой плановый заказ не зависит от этого.",
      message: "Сообщение к действию",
      deltaDays: "(дней: {{count}})",
      deltaDays_one: "(дней: {{count}})",
      acceptConfirm: "Принять: {{message}}?",
      messageNow: "Теперь в нём: {{message}}.",
      messageGone: "Сообщения у заказа больше нет.",
      lastDismissed: "Последнее отклонённое: {{message}}. Причина: {{reason}}",
      firmedDone: "Заказ {{number}} закреплён.",
      cancelledDone: "Заказ {{number}} отменён.",
      convertedDone: "Заказ {{number}} передан в работу.",
      convertBuy:
        "Заказ на закупку закрепляется и планируется как любой другой, но здесь его нельзя передать в работу.",
      acceptedDone: "Сообщение по заказу {{number}} принято.",
      dismissedDone: "Сообщение по заказу {{number}} отклонено.",
    },
    waterfall: {
      step: "Шаг",
      before: "До",
      term: "Слагаемое",
      after: "После",
      scrap_batch: "На партию",
      scrap_component: "Отходы компонента",
      scrap_assembly: "Отходы сборки",
      scrap_operation: "Отходы операции {{step}}",
      item_needs: "Итого по этой потребности",
      gross: "Валовая потребность",
      remnants_matched: "Остатки",
      remnant: "Остаток {{no}}",
      remnant_length: "Остаток {{no}}, {{length}} м",
      on_hand: "В наличии",
      offcuts_matched: "в том числе обрезки, отложенные для объединённых строк",
      reserved: "Зарезервировано под другие заказы, не учитывается",
      in_transit: "В пути",
      open_supply: "Открытые производственные заказы и закупки",
      firmed: "Закреплённые плановые заказы",
      co_by_products: "Сопутствующая и побочная продукция",
      lot_excess_carried: "Перенесённый остаток партии",
      net: "Чистая потребность",
      lot_for_lot: "Размер партии: под потребность",
      min_multiple: "Размер партии: не меньше {{min}}, кратно {{multiple}}",
      mps_cell: "Утверждённая ячейка графика",
      mps_committed: "Уже закреплено",
      mps_overflow: "Закреплено сверх ячейки",
      mps_excess: "Сверх утверждённой ячейки",
    },
    timeline: {
      need: "Потребность",
      due: "Срок",
      start: "Начало",
      release: "Выпуск",
      due_snap: "Сдвинуто на {{days}} дн. назад, на последний рабочий день",
      routing_time:
        "Время по маршруту: {{days}} раб. дн., операций {{ops}}, {{minutes}} мин ({{centres}})",
      lead_time_days: "Срок поставки: {{days}} раб. дн.",
      source_snap: "Сдвинуто на {{days}} дн. назад, на рабочий день площадки {{facility}}",
      release_buffer: "Запас до выпуска: {{days}} раб. дн.",
      version_repicked: "Спецификация или маршрут выбраны заново на дату начала",
      clamped: "Перенесено на сегодня",
      skippedDate: "{{date}} закрыт",
      exceptions: "Исключения календаря, закрывшие дни: {{count}}.",
      exceptions_one: "Исключения календаря, закрывшие дни: {{count}}.",
    },
    note: {
      exceeds_approved_mps: "Планирует больше утверждённого графика.",
      scrap_applied_on_children: "Отходы учтены на компонентах, а не на этом заказе.",
      position_below_zero: "Прогнозная позиция была ниже нуля.",
      commitment_output_in_on_hand:
        "Уже выпущенное по ячейке ГПП учтено в её заказе на производство, а не повторно как запас.",
      firmed_quantity_kept: "Закреплён, количество сохранено.",
      clamped_to_today: "Прошедшая дата перенесена на сегодня.",
      firmed_dates_kept: "Закреплён, даты сохранены.",
      outsourced_step_not_timed: "Операция на стороне не учтена по времени.",
      source_uncalendared: "У площадки-источника нет календаря.",
      work_center_closed_in_window: "Рабочий центр закрыт в этот период.",
      work_center_uncalendared: "У рабочего центра нет календаря; взяты часы площадки.",
    },
  },
  mrp: {
    title: "MRP",
    loading: "Загрузка расчётов MRP…",
    loadError: "Не удалось загрузить расчёты MRP.",
    emptyTitle: "Расчётов MRP ещё не было",
    emptyBody: "Утвердите главный график или запустите MRP.",
    historyTitle: "История расчётов MRP",
    run: "Запустить MRP",
    running: "Идёт расчёт MRP…",
    runGroup: "Запустить по всей группе",
    groupStarting: "Запуск…",
    rerun: "Запустить снова",
    runDone: "{{run}} завершён в {{time}}.",
    runFailed: "{{run}} завершился ошибкой.",
    requestFailed: "Не удалось запустить MRP. ID запроса: {{requestId}}",
    groupScopeRequired: "Для расчёта по всем площадкам нужны права MRP на уровне группы.",
    groupRunning: "Расчёт по группе уже идёт ({{id}}). Он планирует и эту площадку.",
    groupRunningUnnamed: "Расчёт по группе уже идёт. Он планирует и эту площадку.",
    groupStarted: "Расчёт по группе запущен, в таком порядке: {{order}}.",
    groupSkipped: "Пропущены, нет календаря и нечего планировать: {{names}}.",
    failures:
      "Неудачных расчётов MRP подряд: {{count}}. Показаны плановые заказы последнего успешного расчёта.",
    nightlySkipped:
      "Нет календаря и нечего планировать: ночной расчёт пропустил эту площадку {{date}}.",
    mpsExceeded: "Недель, где MRP планирует больше утверждённого графика: {{count}}.",
    proposeNow: "Предложить сейчас",
    openCalendars: "Открыть календари",
    graphExcluded:
      "Часть продуктов исключена из-за ошибки спецификации. Откройте расчёт, чтобы увидеть какие.",
    fixpoint: {
      converged: "Последний расчёт по группе сошёлся после прохода {{pass}}.",
      not_reached:
        "Последний расчёт по группе не сошёлся после прохода {{pass}}. Заказы на перемещение ещё могут измениться.",
    },
    status: {
      queued: "В очереди",
      running: "Идёт",
      succeeded: "Успешно",
      failed: "Ошибка",
    },
    trigger: {
      mps_approval: "Утверждён график",
      manual: "Вручную",
      transfer_projection: "Спрос на перемещение",
      cron: "Ночной",
    },
    error: {
      FACILITY_CALENDAR_MISSING: "У площадки нет календаря, поэтому MRP не может планировать даты.",
      DEMAND_REFRESH_FAILED: "Не удалось нужное обновление спроса.",
      LEASE_EXPIRED: "Расчёт перестал отвечать и был прекращён.",
      SHUTDOWN: "Расчёт остановлен перезапуском.",
      PLANNED_ORDERS_CHANGED:
        "Плановые заказы менялись во время расчёта, и после повторов он прекращён.",
      TRANSFER_FIXPOINT_NOT_REACHED: "Заказы на перемещение между площадками не сошлись.",
      COMPUTE_FAILED: "План не удалось рассчитать.",
    },
    columns: {
      run: "Расчёт",
      created: "Начат",
      trigger: "Кем запущен",
      status: "Статус",
      duration: "Длительность",
      createdOrders: "Создано",
      updatedOrders: "Изменено",
      cancelledOrders: "Отменено",
      messages: "Сообщения",
      error: "Ошибка",
    },
    tiles: {
      mrp: "MRP",
      noRun: "Расчётов ещё не было",
      queued: "В очереди, запуск в {{time}}",
      orders: "Плановые заказы",
      summaryError: "Не удалось прочитать счётчики",
      byStatus: {
        proposed: "предложено: {{count}}",
        firmed: "закреплено: {{count}}",
      },
      byKind: {
        manufacture: "производство: {{count}}",
        purchase: "закупка: {{count}}",
        transfer: "перемещение: {{count}}",
      },
      messages: "Сообщения к действию",
      noMessages: "Ничего не ждёт",
    },
  },
  mrpRun: {
    title: "Расчёт MRP",
    loading: "Загрузка расчёта…",
    loadError: "Не удалось загрузить расчёт.",
    notFound: "Такого расчёта нет или он вне вашей зоны доступа.",
    back: "К рабочему месту",
    narrowed: "Вам видны только счётчики заказов на закупку.",
    header: "Расчёт",
    facility: "Площадка",
    triggerCount: "Объединено запросов",
    created: "Поставлен в очередь",
    due: "Срок запуска",
    started: "Начат",
    finished: "Завершён",
    duration: "Длительность",
    plan: "Прочитанный главный график",
    noPlan: "Утверждённого графика нет; планирование по пулу спроса",
    planLink: "Открыть главный график",
    refresh: "Прочитанное обновление спроса",
    refreshLink: "Открыть пул спроса",
    horizon: "Горизонт",
    weeks: "Недель: {{count}}",
    weeks_one: "Недель: {{count}}",
    orchestration: "Расчёт по группе",
    single: "Отдельный расчёт",
    pass: "Проход {{pass}}",
    depth: "Глубина распространения",
    conflictRetries: "Повторы из-за конфликтов",
    levels: "Самый глубокий уровень спецификации",
    counts: "Счётчики",
    noCounts: "Счётчиков пока нет. У расчёта в очереди или в работе их нет.",
    count: {
      productsPlanned: "Продуктов спланировано",
      created: "Заказов создано",
      updated: "Заказов изменено",
      cancelled: "Заказов отменено",
      messages: "Сообщений к действию",
      optionalSkipped: "Пропущено необязательных строк спецификации",
      remnantMismatch: "Остатков, не совпавших с реестром",
      shutdownRequeues: "Возвращено в очередь перезапуском",
    },
    byKind:
      "{{kind}}: продуктов {{planned}}, создано {{created}}, изменено {{updated}}, отменено {{cancelled}}, сообщений {{messages}}",
    lists: "Что сообщил расчёт",
    noLists: "Пока ничего не сообщено.",
    none: "Нет",
    more: "Ещё не показано: {{count}}.",
    list: {
      skipped: "Строки спецификации исключены, единица не пересчитывается",
      skipped_work_orders:
        "Открытые производственные заказы вне расчёта: количество не пересчитывается",
      no_bom: "Продукты без спецификации",
      supply_limited: "Продукты с нехваткой снабжения",
      defaulted_parameters: "Продукты, спланированные по параметрам по умолчанию",
      transfer_source_inactive: "Перемещения с неактивным источником",
      depth_exceeded: "Цепочки глубже 12 уровней",
      bom_cycle: "Циклы в спецификациях",
      byproduct_cycle: "Циклы побочной продукции",
      product_cycles: "Циклы продуктов между площадками",
      uncalendared_work_centers: "Рабочие центры без календаря",
      closed_work_centers: "Рабочие центры, закрытые в горизонте",
      closed_facility_windows: "Закрытые периоды площадок",
      mps_exceeded: "Недели сверх утверждённого графика",
      mps_unplanned: "Продукты графика, не спланированные MRP",
    },
    skipReason: {
      UOM_NOT_CONVERTIBLE: "единица не пересчитывается",
      OUTPUT_UOM_NOT_CONVERTIBLE: "единица выпуска не пересчитывается",
      MEASURE_PRECISION_LOSS: "количество нельзя пересчитать точно",
    },
    leadSource: {
      product: "из карточки продукта",
      zero: "не задан",
    },
    unplannedReason: {
      no_plan: "нет утверждённого графика",
      no_cell: "нет ячейки в графике",
    },
    entry: {
      skipped: "Строка {{line}}: {{reason}}",
      skippedOrder: "{{order}}: {{reason}}",
      from: "с {{date}}",
      defaulted: "{{product}} ({{kind}}): срок {{days}} дн., {{source}}",
      transferInactive: "{{product}} с площадки {{facility}}",
      window: "{{facility}}: с {{from}} по {{to}}",
      week: "неделя с {{date}}",
      unplanned: "{{product}}: {{reason}}",
    },
    ordersOfRun: "Плановые заказы этого расчёта",
  },
  // The finite schedule (spec 03 §4.1, §4.6 to §4.8, P3-I-2, D-406 ruling 8).
  schedule: {
    title: "График",
    loading: "Загрузка графика…",
    loadError: "Не удалось загрузить график.",
    emptyTitle: "Графика пока нет",
    emptyBody:
      "Утвердите плановые заказы или выпустите производственные заказы, затем рассчитайте график.",
    filteredTitle: "Под фильтры ничего не подходит",
    filteredBody: "В эти дни нет операций, подходящих под: {{filters}}.",
    firstDraft: "Первый график этой площадки ждёт публикации.",
    version: "Версия {{version}}",
    publishedAt: "Опубликован {{time}}",
    publishedAuto: "Опубликован автоматически",
    publishedByPerson: "Опубликован человеком",
    draftOnly: "Ещё не опубликован",
    unplacedMore: "Не показано неразмещённых операций: {{count}}.",
    unplacedMore_one: "Не показано неразмещённых операций: {{count}}.",
    zoneNote: "Время указано по часовому поясу площадки: {{zone}} ({{offset}}).",
    lastSolve: "Последний расчёт {{time}}",
    pending: "Расчёт в очереди после изменений: {{count}}, запуск в {{time}}.",
    pending_one: "Расчёт в очереди после изменений: {{count}}, запуск в {{time}}.",
    pendingUrgent: "Ждёт срочное изменение. Расчёт запускается сейчас.",
    failures: "Неудачных расчётов подряд: {{count}}. На доске последний опубликованный график.",
    daysLabel: "Показать дней",
    days: "{{count}} дн.",
    zoomLabel: "Масштаб",
    zoomWeek: "Неделя",
    zoomDay: "День",
    earlier: "Раньше",
    later: "Позже",
    range: "с {{from}} по {{to}}",
    times: "{{start}} – {{end}}",
    kpis: {
      lateOrders: "Заказы с опозданием",
      lateDays: "Дни опоздания",
      setupMinutes: "Минуты переналадки",
      overloads: "Перегрузки",
      unplaced: "Не размещено",
    },
    filters: {
      order: "Номер заказа",
      product: "Продукт",
      key: "Ключ наладки",
      workCenter: "Рабочий центр",
    },
    lane: {
      tooltip:
        "Одна линия на рабочий центр: параллельные машины планируются как одна линия, пока нет учёта оборудования",
      noCapacity: "В эти дни нет рабочего времени",
      utilization: "Загрузка {{pct}} %",
      availabilityUnbound: "Доступность 100 %. Для снижения нужны данные обслуживания",
      availability: "Доступность {{pct}} %",
      blocked: "Остановлен обслуживанием",
      unplacedTitle: "Не размещено: {{count}}",
    },
    block: {
      aria: "{{order}}, {{step}}, с {{start}} по {{end}}",
      workOrder: "Производственный заказ",
      plannedOrder: "Плановый заказ",
      inProgress: "В работе",
      pinned: "Закреплена",
      fenced: "Оставлена на месте замороженным периодом",
      fencedShort: "Заморожена",
      late: "Опоздание",
      setup: "Переналадка {{minutes}} мин",
      setupShort: "{{minutes}}′",
    },
    unplaced: {
      work_center_uncalendared: "Календарь не назначен. Мощность нулевая.",
      work_center_blocked: "Остановлен обслуживанием.",
      no_capacity: "В окне поиска не осталось рабочего времени.",
      on_hold: "Задержана контролем качества",
      predecessor_unplaced: "Предыдущий шаг не размещён.",
      no_routing: "У заказа нет маршрута.",
    },
    runStatus: {
      running: "Расчёт",
      succeeded: "Готово",
      failed: "Ошибка",
    },
    trigger: {
      cron: "Ночной",
      event: "Изменение",
      manual: "Человек",
      drag_preview: "Предпросмотр",
      commit_move: "Перенос",
      apply_move: "Применённый вариант",
      ctp_probe: "Проверка обещания",
      scenario: "Сценарий",
    },
    runError: {
      LEASE_EXPIRED: "Расчёт перестал отвечать и был остановлен.",
      SHUTDOWN: "Система перезапустилась во время расчёта. Расчёт повторится.",
      TOO_MANY_OPERATIONS: "На площадке больше 5 000 операций, слишком много для одного расчёта.",
      COMPUTE_FAILED: "Не удалось рассчитать график.",
    },
    solve: {
      button: "Рассчитать",
      running: "Расчёт…",
      queued: "Расчёт уже идёт. Ваш запустится сразу после него.",
      requestFailed: "Не удалось запустить расчёт. ID запроса: {{requestId}}",
      outcome: {
        wrote: "Рассчитано. Новый план ждёт публикации.",
        short_circuit: "С прошлого расчёта ничего не изменилось, новая версия не записана.",
        stale_base: "Во время расчёта был опубликован график. Расчёт повторяется.",
        empty: "На этой площадке нечего планировать.",
        auto_published: "Рассчитано и опубликовано автоматически.",
        failed: "Расчёт не удался.",
        running: "Расчёт…",
      },
    },
    overload: {
      aria: "Перегрузка {{hours}} ч в {{week}}",
      marker: "Сверх: {{hours}} ч",
      title: "Перегрузка: {{wc}}, {{week}}",
      body: "Работа на {{hours}} ч со сроком до {{date}} не успевает к этой дате: нужно {{required}} ч при мощности {{capacity}} ч.",
      lateOps: "Опаздывающие или неразмещённые операции: {{count}}",
      noLateOps: "Ни одна операция этой недели не опаздывает.",
      due: "срок {{date}}",
      unplaced: "не размещена",
      more: "Не показано: {{count}}.",
    },
    moves: {
      title: "Как её снять",
      scoring: "Оценка…",
      scoringNote: "Варианты оцениваются по опубликованному плану.",
      abandoned: "Не оценено: опубликован более новый график.",
      none: "Для этой перегрузки не нашлось ни одного варианта.",
      rank: "Вариант {{rank}}",
      kind: {
        overtime: "Сверхурочные",
        alternate_work_center: "Другой рабочий центр",
        push_order: "Сдвинуть заказ",
      },
      overtime: "Добавить {{hours}} ч дополнительной смены на {{wc}}",
      alternate: "Перенести операции ({{count}}), {{hours}} ч работы, с {{from}} на {{to}}",
      alternate_one: "Перенести операции ({{count}}), {{hours}} ч работы, с {{from}} на {{to}}",
      push: "Выполнять {{order}} после всех остальных заказов на {{wc}}, освободив {{hours}} ч",
      interval: "с {{from}} до {{to}}",
      op: "{{order}} · шаг {{no}}, {{minutes}} мин",
      effectLate: "Опаздывающих заказов: сейчас {{before}}, после {{after}}",
      effectLatePending: "Опаздывающих заказов: сейчас {{before}}. Оценка…",
      effectLateUnscored:
        "Опаздывающих заказов: сейчас {{before}}. Не оценено: пересчёты ушли на более крупные перегрузки.",
      effectLateAbandoned:
        "Опаздывающих заказов: сейчас {{before}}. Не оценено: опубликован более новый график.",
      clears: "Снимает перегрузку",
      notClears: "Не снимает перегрузку",
      cost: "Стоимость {{cost}}",
      atRisk: "Под риском стоимость заказов {{value}}",
      costHidden: "Стоимость скрыта",
      unpriced: {
        currency_mismatch: "Без оценки: ставки в другой валюте",
        no_rate: "Без оценки: у рабочего центра нет ставки труда",
        no_standard_cost: "Без оценки: нет нормативной себестоимости",
      },
      atRiskUnpriced: {
        currency_mismatch: "Стоимость заказов под риском не оценена: затраты в другой валюте",
        no_rate: "Стоимость заказов под риском не оценена",
        no_standard_cost: "Стоимость заказов под риском не оценена: нет нормативной себестоимости",
      },
      apply: "Применить",
      applying: "Применение…",
      overtimeAdmin: "Сверхурочные применяет администратор площадки",
      readOnly: "Варианты применяют планировщик или администратор площадки.",
      confirmTitle: "Применить этот вариант?",
      confirmOvertime:
        "В календарь {{wc}} будут добавлены эти дополнительные смены, затем план будет рассчитан и опубликована новая версия:",
      confirmAlternate:
        "Эти операции будут закреплены за {{to}}, затем план будет рассчитан и опубликована новая версия:",
      confirmPush:
        "Заказ {{order}} будет выполняться после всех остальных, пока отсрочку не снимут в разделе «Закрепления». Затем план пересчитывается и публикуется.",
      back: "Назад к вариантам",
      applied: "Применено: {{move}}, {{who}}, {{time}}.",
      alreadyApplied: "Вариант для этой перегрузки уже применён. Доска перечитана.",
      notFound: "Этот вариант больше не предлагается. Варианты перечитаны.",
      denied: "Чтобы применить этот вариант, нужно: {{codes}}.",
      code: {
        calendar: "право изменять календари",
        cost: "право видеть затраты",
      },
      notApplicable: {
        order_closed: "Заказ закрыт после того, как был предложен этот вариант.",
        work_center_archived:
          "Рабочий центр архивирован после того, как был предложен этот вариант.",
        operation_done: "Операция завершена после того, как был предложен этот вариант.",
      },
      failed: "Не удалось применить вариант. ID запроса: {{requestId}}",
    },
    move: {
      promised: "Обещано клиенту",
      promisedNo: "Обещано клиенту: {{number}}",
      title: "Что изменит перенос",
      heading: "{{order}} · {{step}} на {{time}}, {{wc}}",
      previewing: "Рассчитываем, что изменит перенос…",
      formTitle: "Перенести операцию",
      start: "Новое начало",
      lane: "Рабочий центр",
      earlier: "На 1 ч раньше",
      later: "На 1 ч позже",
      preview: "Показать результат",
      invalidStart: "Укажите дату и время.",
      sameSpot: "Сначала выберите другое начало или рабочий центр.",
      blocked: {
        in_progress: "Начатую операцию нельзя перенести.",
        outsourced: "Шаг на стороне не занимает линию, его нельзя перенести.",
        on_hold: "Шаг на карантине качества нельзя перенести, пока карантин не снят.",
      },
      pinned:
        "Закреплена на этом начале. Снимите закрепление в разделе «Закрепления», чтобы расчёт мог её сдвинуть.",
      pinReleased: "Последний расчёт снял закрепление этой операции.",
      phone: "Операции переносятся на большом экране.",
      dragHint:
        "Перетащите блок по его линии или на другую допустимую линию, чтобы увидеть, что изменит перенос. В карточке каждого блока есть и форма переноса.",
      laneNotAllowed: "Этот шаг нельзя выполнять на {{wc}}.",
      dragTo: "{{time}}, {{wc}}",
      newlyLate: "Заказы, которые начнут опаздывать: {{count}}",
      resolved: "Заказы, которые перестанут опаздывать: {{count}}",
      noneLate: "Ни один заказ не начнёт опаздывать.",
      noneResolved: "Нет",
      slip: "{{order}}, срок {{due}}, окончание {{end}} вместо {{old}}: опоздание, дней: {{count}}",
      slip_one:
        "{{order}}, срок {{due}}, окончание {{end}} вместо {{old}}: опоздание, дней: {{count}}",
      orderFor: "{{order}} для {{customer}}",
      gain: "{{order}}, срок {{due}}, теперь окончание {{end}}",
      unplacedEnd: "не размещена",
      moved: "Операции, которые он сдвигает: {{count}}",
      more: "Не показано: {{count}}.",
      kpis: "Изменение плана",
      newOverloads: "Новые перегрузки: {{count}}",
      precedence:
        "Это начало раньше окончания предыдущего шага ({{time}}), а заказ так выполнить нельзя. Выберите более позднее начало.",
      confirm: "Подтвердить",
      confirming: "Сохранение…",
      cancel: "Отмена",
      stale: "План изменился, пока вы смотрели. Вот новый результат.",
      previewAgain: "Показать заново",
      refused: {
        OP_IN_PROGRESS: "Начатую операцию нельзя перенести.",
        OP_NOT_MOVABLE: "Шаг на карантине качества или на стороне нельзя перенести.",
        MOVE_IN_PAST: "Это начало уже в прошлом.",
        WORK_CENTER_NOT_ALLOWED: "Этот шаг нельзя выполнять на этом рабочем центре.",
        PIN_OVERLAPS_FIXED_WORK:
          "Это место пересекается с работой, которую нельзя сдвинуть: начатым шагом или другим закреплением.",
        SCHEDULE_OPERATION_NOT_FOUND: "Этой операции больше нет в графике.",
        MOVE_BREAKS_PRECEDENCE:
          "Перенос начнёт шаг раньше окончания предыдущего. Выберите более позднее начало.",
        SCHEDULE_RUN_NOT_FOUND: "Результат больше недоступен. Покажите его заново.",
      },
      failed: "Не удалось рассчитать или сохранить перенос. ID запроса: {{requestId}}",
      ghost: "Новое место {{order}}, с {{start}} до {{end}}",
      outcome: {
        moved: "Перенесено и закреплено. Опубликована версия {{version}}.",
        applied: "Вариант применён. Опубликована версия {{version}}.",
        superseded: "Опубликован более новый график. Доска обновлена.",
      },
    },
    kpiDelta: {
      late_orders: "Опаздывающие заказы",
      total_late_days: "Дни опоздания",
      total_setup_minutes: "Минуты переналадки",
      overloads: "Перегрузки",
      unplaced: "Не размещено",
      makespan_hours: "Часы до окончания всей работы",
    },
    pins: {
      button: "Закрепления ({{count}})",
      buttonLoading: "Закрепления",
      title: "Закрепления и отложенные заказы",
      loading: "Загрузка закреплений…",
      loadError: "Не удалось загрузить закрепления.",
      emptyTitle: "Ничего не закреплено",
      emptyBody:
        "Перетащите блок на доске, чтобы закрепить его, или примените вариант для перегрузки.",
      kind: {
        pin_position: "Закреплено на месте",
        pin_work_center: "Оставлено на рабочем центре",
        defer: "Отложено",
      },
      origin: {
        commit_move: "перенос на доске",
        apply_move: "применённый вариант",
      },
      at: "с {{time}}",
      on: "на {{wc}}",
      step: "шаг {{no}} · {{name}}",
      since: "С {{time}}, источник: {{origin}}",
      unpin: "Открепить",
      undefer: "Снять отсрочку",
      removing: "Снятие…",
      removed: "Снято. Следующий расчёт разместит эту работу свободно.",
      notActive: "Это закрепление уже снято. Список перечитан.",
      failed: "Не удалось снять закрепление. ID запроса: {{requestId}}",
      readOnly: "Закрепления снимают планировщик или администратор площадки.",
    },
    drawer: {
      label: "Операция заказа {{order}}",
      product: "Продукт",
      qty: "Количество",
      salesOrder: "Заказ клиента",
      step: "Шаг",
      stepText: "{{no}} · {{name}}",
      workCenter: "Рабочий центр",
      start: "Начало",
      end: "Окончание",
      sequence: "Позиция на линии",
      notPlaced: "Не размещена",
      run: "Работа",
      runText: "Работа {{run}} мин и переналадка {{setup}} мин, по часам {{wall}} мин",
      runOnly: "Работа {{run}} мин",
      due: "Срок",
      noDue: "Без срока",
      lateBy: "Опоздание, дней: {{count}}",
      lateBy_one: "Опоздание, дней: {{count}}",
      dueSameDay: "заканчивается в день срока",
      spare: "Запас, дней: {{count}}",
      spare_one: "Запас, дней: {{count}}",
      priority: "Приоритет",
      batch: "Серия",
      noBatch: "Не входит в серию",
      batchKeyOnly: "Идёт серией с ключом {{key}}",
      batchWith: "Идёт вместе с {{orders}} с ключом {{key}} без переналадки между ними",
      changeover: "Переналадка",
      noChangeover: "Без переналадки",
      changeoverMinutes: "{{minutes}} мин",
      key: "Ключ наладки {{key}}",
      previousUnknown: "Предыдущая работа на этой линии вне показанных дней.",
      keyMissing: "Ключа наладки нет, поэтому действуют минуты наладки шага маршрута.",
      explaining: "Расчёт переналадки…",
      explainError: "Не удалось загрузить, как рассчитана переналадка.",
    },
    draft: {
      title: "Новый план ждёт",
      badge: "Новый план ждёт (версия {{version}})",
      waiting: "Новый план ждёт",
      review: "Проверить и опубликовать",
      notDraft: "План изменился, пока вы его смотрели. Вот более новый.",
      failed: "Не удалось принять решение по плану. ID запроса: {{requestId}}",
      heldBy: "План ждёт человека, потому что:",
      loading: "Загрузка изменений плана…",
      loadError: "Не удалось загрузить изменения плана.",
      first: "Нет опубликованного графика для сравнения.",
      moved: "Перенесённые операции: {{count}}",
      movedNone: "Операции не переносятся.",
      movedText: "с {{from}} на {{to}}",
      laneChanged: "с {{from}} на {{to}}",
      more: "Не показано: {{count}}.",
      newOverloads: "Новые перегрузки: {{count}}",
      clearedOverloads: "Снятые перегрузки: {{count}}",
      none: "Нет",
      discard: "Отклонить",
      discarding: "Отклонение…",
      publish: "Опубликовать",
      publishing: "Публикация…",
      readOnly: "План публикует планировщик или администратор площадки.",
      outcome: {
        published: "Версия {{version}} опубликована. Цех работает по ней.",
        discarded: "План отклонён. Действует опубликованный график.",
        superseded: "Опубликован более новый график. Данные обновлены.",
        decided: "По этому плану уже принято решение. На доске действующий график.",
      },
    },
    held: {
      first_schedule: "Это первый график площадки.",
      auto_publish_off: "Автоматическая публикация на площадке выключена.",
      ops_moved: "Он переносит операции дальше их допуска.",
      new_overloads: "В нём есть новые перегрузки.",
      pins_released: "Он снял закрепление операции.",
    },
    heldShort: {
      first_schedule: "первый график",
      auto_publish_off: "автопубликация выключена",
      ops_moved: "операции перенесены",
      new_overloads: "новые перегрузки",
      pins_released: "закрепление снято",
    },
    phone: {
      lane: "Рабочий центр",
      prevDay: "Предыдущий день",
      nextDay: "Следующий день",
      none: "На этой линии в этот день ничего не запланировано.",
      overloads: "Перегрузки",
    },
    workbench: {
      title: "График",
      schedule: "Опубликованный график",
      noPublished: "Пока ничего не опубликовано",
      lateOrders: "Заказы с опозданием: {{count}}",
      overloads: "Перегрузки: {{count}}",
      lastSolve: "Последний расчёт",
      noSolve: "Расчётов ещё не было",
      queued: "В очереди, запуск в {{time}}",
      overloadTile: "Открытые перегрузки",
      noOverloads: "Нет",
    },
  },
  capacity: {
    title: "Мощности",
    loading: "Загрузка мощностей…",
    loadError: "Не удалось загрузить мощности.",
    draftError: "Не удалось загрузить мощности ожидающего плана.",
    noCalendarsTitle: "Календари не настроены",
    noCalendarsBody: "Назначьте графики смен в разделе «Календари».",
    openCalendars: "Открыть календари",
    emptyTitle: "Графика пока нет",
    emptyBody:
      "Утвердите плановые заказы или выпустите производственные заказы, затем рассчитайте график.",
    noRows: "В опубликованном графике нет рабочих центров с мощностью или загрузкой.",
    noCapacity:
      "Ни у одного рабочего центра нет рабочего времени в эти дни. Назначьте графики смен в разделе «Календари».",
    grainLabel: "Показать по",
    grain: {
      week: "Неделям",
      day: "Дням",
    },
    range: "Версия {{version}}, с {{from}} по {{to}}",
    showDraft: "Сравнить с ожидающим планом",
    figures: "Размещено {{placed}} ч из {{capacity}} ч · к сроку {{due}} ч",
    proposed: "Предложено, не утверждено: {{hours}} ч",
    overload: "Сверх: {{hours}} ч",
    delta: "Ожидающий план: {{hours}} ч",
  },
  matrix: {
    title: "Матрица переналадок",
    loading: "Загрузка времени переналадок…",
    loadError: "Не удалось загрузить время переналадок.",
    noWcTitle: "На площадке нет рабочих центров",
    noWcBody: "Добавьте рабочие центры площадки, прежде чем задавать время переналадок.",
    readOnly: "Вы можете смотреть время переналадок. Меняет его администратор площадки.",
    phoneReadOnly: "Время переналадок редактируется на большом экране.",
    workCenter: "Рабочий центр",
    saveFirst: "Сохраните или отмените изменения, прежде чем выбрать другой рабочий центр.",
    unused: "Не используется ни одним маршрутом на этой линии",
    from: "С",
    to: "На",
    minutes: "Минуты",
    lint: "Проверка",
    any: "любое значение",
    absent: "признака нет в ключе",
    opaqueFacet: "Ключи свободной формы",
    facet: "Признак {{facet}}",
    emptyTitle: "Нет времени переналадок",
    emptyBody: "Планировщик берёт минуты наладки каждого шага маршрута.",
    addRow: "Добавить строку",
    removeRow: "Удалить эту строку",
    remove: "Удалить",
    newFacet: "Новый признак",
    addFacet: "Добавить признак",
    facetInvalid:
      "Признак: строчные латинские буквы, цифры и _, начиная с буквы, не длиннее 32 символов.",
    discard: "Отменить изменения",
    fixRows: "Строк, которые нужно исправить перед сохранением: {{count}}.",
    fixRows_one: "Строк, которые нужно исправить перед сохранением: {{count}}.",
    tooMany: "У рабочего центра не больше {{max}} строк.",
    saved: "Сохранено. Строк переналадки на линии: {{count}}.",
    saved_one: "Сохранено. Строк переналадки на линии: {{count}}.",
    reason: {
      facet_malformed: "Признак не соответствует правилам ключа.",
      value_malformed: "Значение не является значением ключа, * или -.",
      same_value: "«С» и «На» совпадают, это не переналадка.",
      duplicate_row: "Такая переналадка уже есть в списке.",
      minutes_out_of_range: "Минуты: целое число от 0 до 1440.",
    },
    basis: {
      missing_key: "Одного из ключей нет, поэтому действуют минуты наладки шага маршрута.",
      same_key: "Ключи совпадают, переналадки нет.",
      matrix: "Для каждого изменяемого признака есть строка, переналадка равна их сумме.",
      matrix_incomplete:
        "Для изменяемого признака нет строки, поэтому переналадка равна большему из суммы строк и минут наладки шага маршрута.",
    },
    test: {
      title: "Проверить переналадку",
      body: "Введите ключ, с которым линия работала последним, и ключ следующей работы, чтобы увидеть, сколько начислит планировщик.",
      savedOnly: "Проверяются сохранённые строки. Сохраните изменения, чтобы проверить их.",
      from: "Ключ «с»",
      to: "Ключ «на»",
      static: "Минуты наладки маршрута",
      run: "Проверить",
      running: "Проверка…",
      error: "Не удалось проверить переналадку.",
      result: "Переналадка: {{minutes}} мин",
      facetRow: "{{facet}}: {{from}} → {{to}}, по строке {{rowFrom}} → {{rowTo}}, {{minutes}} мин",
      facetNoRow: "{{facet}}: {{from}} → {{to}}, строки нет",
    },
  },
  // §4.9 Promises and the shared CTP dialog (P3-J-1, D-474).
  promises: {
    tile: {
      title: "Обещания",
      atRisk: "Под угрозой",
      broken: "Нарушено за 30 дней",
      upcoming: "Сроки в ближайшие 7 дней",
      upcomingNone: "На ближайшие 7 дней ничего не обещано.",
      empty: "Обещаний под угрозой нет.",
      atLeast: "{{count}}+",
      next: "{{number}} · {{date}}",
    },
    title: "Обещания",
    checkDate: "Проверить дату",
    loading: "Загрузка обещаний…",
    loadError: "Не удалось загрузить обещания.",
    emptyTitle: "Обещаний пока нет",
    emptyBody: "Проверьте дату из коммерческого предложения или заказа.",
    filteredEmptyTitle: "Нет подходящих обещаний",
    filteredEmptyBody: "Ничего не подходит под фильтр: {{filters}}.",
    salesOrder: "Заказ клиента",
    customer: "Клиент",
    columns: {
      promiseNo: "Обещание",
      product: "Продукт",
      qty: "Количество",
      customer: "Клиент",
      order: "Заказ",
      requested: "Запрошено",
      promised: "Обещано",
      projected: "Прогноз",
      path: "Источник",
      status: "Статус",
      risk: "Риск",
      source: "Откуда",
    },
    filters: {
      status: "Статус",
      live: "Действующие",
      from: "Обещано с",
      to: "Обещано по",
      product: "Продукт",
      customer: "Клиент",
      order: "Заказ",
      anyOrder: "Любой заказ этого клиента",
      orderNeedsCustomer: "Сначала выберите клиента",
    },
    filterTag: {
      status: "Статус: {{status}}",
      from: "С {{date}}",
      to: "По {{date}}",
      product: "Продукт: {{product}}",
      customer: "Один клиент",
      order: "Один заказ",
      customerNamed: "Клиент: {{customer}}",
      orderNamed: "Заказ: {{order}}",
    },
    customerPicker: {
      placeholder: "Название или номер клиента",
      results: "Найденные клиенты",
      searching: "Поиск…",
      error: "Не удалось найти клиентов.",
      none: "Клиентов не найдено.",
    },
    status: {
      quoted: "Предложено",
      committed: "Подтверждено",
      at_risk: "Под угрозой",
      broken: "Нарушено",
      kept: "Выполнено",
      withdrawn: "Отозвано",
      expired: "Истекло",
    },
    path: {
      offcut: "Обрезки",
      stock: "Склад",
      production: "Производство",
      transfer: "Перемещение",
    },
    source: {
      dialog: "Проверено человеком",
      agent: "Агент",
      confirmation: "Подтверждение заказа",
      re_promise: "Новое обещание",
    },
    risk: {
      stock_consumed: "Остатки ушли на другое",
      material_delay: "Материал опаздывает",
      capacity_loss: "Потеря мощности",
      schedule_slip: "График сдвинулся",
    },
    withdrawnReason: {
      manual: "Отозвано вручную",
      re_promised: "Заменено новым обещанием",
      order_cancelled: "Заказ отменён",
      line_cancelled: "Строка отменена",
    },
    basis: {
      title: "На чём основано",
      none: "Проверять нечего.",
      offcut: "Обрезок, {{length}} м",
      stock: "Со склада: {{qty}}",
      inTransit: "В пути: {{qty}}",
      workOrder: "Заказ на производство в плане",
      plannedOrder: "Плановый заказ",
      window: "{{workCenter}}, с {{from}} по {{to}}",
      workCenter: "Рабочий центр",
      material: {
        on_hand: "{{product}} на складе",
        planned_order: "{{product}} поступит {{date}}",
        lead_time: "{{product}} будет закуплен к {{date}}",
      },
      holds: "В силе",
      broken: "Уже не в силе",
      unchecked: "Ещё не проверено",
      margin: "Страховой запас времени: {{count}} дн.",
      beyondHorizon: "Оценка за пределами графика на {{days}} дн.",
      beyondHorizonShort: "Оценка за пределами графика",
    },
    verdict: {
      title: "Итог",
      kept: "Отгружено вовремя",
      broken: "Отгружено с опозданием или не полностью",
      onTime: "Вовремя: {{qty}} из {{judged}}",
      shortfall: "Недопоставка: {{qty}}",
      slip: "Опоздание: {{count}} дн.",
      correctedAt: "Исправлено после поздней отгрузки, {{at}}",
      shipped: "Отгружено {{date}}",
      downgraded: "Почти всё отгружено вовремя, поэтому нарушение считается незначительным.",
      corrected: "Исправлено после поздней отгрузки",
    },
    drawer: {
      label: "Обещание",
      loading: "Загрузка обещания…",
      loadError: "Не удалось загрузить обещание.",
      gone: "Этого обещания больше нет.",
      dates: "Даты",
      earliest: "Самая ранняя",
      validUntil: "Предложение действует до",
      committed: "Подтверждено",
      timeline: "История",
      withdraw: "Отозвать",
      withdrawTitle: "Отозвать это обещание?",
      withdrawReason: "Причина",
      withdrawConfirm: "Отозвать",
      withdrawing: "Отзыв…",
    },
    dialog: {
      title: "Проверить дату",
      product: "Продукт",
      changeProduct: "Изменить",
      qty: "Количество",
      qtyInvalid: "Введите количество больше 0, не более трёх знаков после запятой.",
      requested: "Запрошенная дата",
      facility: "Площадка",
      offcuts: "Использовать обрезки",
      line: "Строка заказа",
      check: "Проверить дату",
      checking: "Проверка…",
      proposed: "Предлагаемая дата",
      earliest: "Самая ранняя возможная: {{date}}",
      byRequested: "К запрошенной дате",
      afterRequested: "Позже запрошенной",
      offcutOption: "Вариант из обрезков",
      offcutUnit: "{{length}} м",
      waste: "Остаток: {{qty}} м",
      validUntil: "Предложение действует до {{at}}.",
      use: "Использовать в КП",
      commit: "Закрепить за строкой заказа",
      committing: "Закрепление…",
      committed: "Готово. {{number}} закреплено за строкой заказа.",
      noDate: "Не удалось найти дату.",
      covered: "Склад покрывает {{covered}}, не хватает {{shortfall}}.",
      stale: "План изменился после этого предложения.",
      newDate: "Новая дата: {{date}}",
      rePromise: "Перенести обещание",
      rePromised: "Обещание перенесено. Теперь у строки дата {{date}}.",
      rePromisedTold: "Обещание перенесено. Теперь у строки дата {{date}}, клиенту сообщат.",
      oldDate: "Сейчас: {{date}}",
      oldDateNone: "У строки пока нет даты.",
      notifyCustomer: "Сообщить клиенту",
      acceptNew: "Принять новую дату",
      noCode: "Ваша роль не может проверять даты. Обратитесь к планировщику.",
    },
    staleReason: {
      date_moved: "Дата сдвинулась.",
      unit_unavailable: "Обрезок больше не свободен.",
      unplaced: "Работа больше не помещается в график.",
    },
    reason: {
      no_routing: "У продукта нет маршрута.",
      no_bom: "У продукта нет спецификации.",
      facility_calendar_missing: "У рабочего центра нет календаря.",
      too_many_operations: "Слишком много операций для одной проверки.",
      probe_unstable: "Проверка не сошлась. Повторите.",
    },
    lineReason: {
      order_not_confirmed: "Заказ не подтверждён.",
      credit_blocked: "Заказ удержан проверкой кредита.",
      line_cancelled: "Строка отменена.",
      line_shipped: "Строка уже отгружена.",
      customer_mismatch: "Строка относится к другому клиенту.",
      product_mismatch: "Строка относится к другому продукту.",
      facility_mismatch: "Строка отгружается с другой площадки.",
      line_mismatch: "Обещание проверялось для другой строки.",
      qty_short: "В строке больше, чем в этом предложении.",
      promise_kept: "Обещание по этой строке уже выполнено, новую дату ей не назначить.",
    },
    refusal: {
      FACILITY_NOT_FOUND: "Этой площадки больше нет.",
      PRODUCT_NOT_FOUND: "Этого продукта больше нет.",
      ORDER_LINE_NOT_FOUND: "Этой строки заказа больше нет.",
      PRODUCT_ARCHIVED: "Этот продукт в архиве.",
      CAPACITY_PATH_UNAVAILABLE: "Не удалось найти дату.",
      CTP_BUSY: "Планировщик занят. Повторите через минуту.",
      PROMISE_NOT_FOUND: "Этого обещания больше нет.",
      PROMISE_NOT_QUOTED: "Это обещание уже не предложение.",
      PROMISE_EXPIRED: "Срок предложения истёк. Проверьте дату снова.",
      ORDER_LINE_REQUIRED: "Выберите строку заказа.",
      ORDER_LINE_NOT_PROMISABLE: "За этой строкой нельзя закрепить обещание.",
      LINE_ALREADY_PROMISED: "За этой строкой уже есть обещание.",
      PROMISE_NOT_WITHDRAWABLE: "Это обещание уже нельзя отозвать.",
      ORDER_NOT_FOUND: "Этого заказа больше нет.",
      PERMISSION_DENIED: "Ваша роль не может менять эту дату. Обратитесь к планировщику.",
      other: "Не получилось. ID запроса: {{requestId}}",
    },
  },
  // Where a work order or a transfer came from (D-396 ruling 23).
  scenarios: {
    title: "Что если",
    newScenario: "Новый сценарий",
    loading: "Загрузка сценариев…",
    loadError: "Не удалось загрузить сценарии.",
    emptyTitle: "Сценариев пока нет",
    emptyBody: "Попробуйте: «Что если скрутка встанет на 5 дней?»",
    filteredEmptyTitle: "Нет подходящих сценариев",
    filteredEmptyBody: "Нет сценариев со статусом «{{status}}».",
    filters: {
      status: "Статус",
      any: "Любой статус",
    },
    filterTag: {
      status: "Статус: {{status}}",
    },
    columns: {
      name: "Сценарий",
      status: "Статус",
      base: "Основа",
      created: "Создан",
      lateDelta: "Просроченные заказы",
    },
    baseVersion: "Версия {{version}}",
    created: "{{who}}, {{time}}",
    agent: "Агент",
    notSolved: "Не рассчитан",
    status: {
      open: "Расчёт",
      solved: "Рассчитан",
      failed: "Ошибка",
      promoted: "Применён",
      discarded: "Отброшен",
    },
    error: {
      NO_PUBLISHED_SCHEDULE: "У площадки нет опубликованного графика для сравнения.",
      TOO_MANY_OPERATIONS: "В сценарии больше 5 000 операций.",
      COMPUTE_FAILED: "Расчёт не удался.",
      LEASE_EXPIRED: "Расчёт шёл слишком долго и был остановлен.",
      SHUTDOWN: "Расчёт прервался.",
    },
    kind: {
      add_shift: "Добавить смену",
      machine_down: "Простой оборудования",
      add_order: "Добавить заказ",
      change_efficiency: "Изменить эффективность",
      drop_order: "Убрать строку заказа",
    },
    codeName: {
      scenarioPromote: "применение сценариев",
      calendarManage: "управление календарями",
      costRead: "просмотр затрат",
    },
    problem: {
      SCENARIO_LIMIT_REACHED:
        "На площадке уже {{limit}} открытых сценариев. Сначала отбросьте один.",
      NO_PUBLISHED_SCHEDULE: "Сначала опубликуйте график: сценарий сравнивается с ним.",
      WORK_CENTER_NOT_FOUND: "Изменение {{n}}: рабочий центр не найден.",
      PRODUCT_NOT_FOUND: "Изменение {{n}}: продукт не найден.",
      ORDER_LINE_NOT_FOUND: "Изменение {{n}}: строка заказа не найдена.",
      SCENARIO_NOT_FOUND: "Сценария больше нет.",
      SCENARIO_NOT_SOLVABLE: "Этот сценарий сейчас нельзя рассчитать заново.",
      SCENARIO_NOT_SOLVED: "Применить можно только рассчитанный сценарий.",
      SCENARIO_CLOSED: "Этот сценарий уже закрыт.",
      NOT_PERSISTABLE: "В этом сценарии нечего сохранять.",
      PERMISSION_DENIED: "Для применения нужно ещё право: {{codes}}.",
      FACILITY_NOT_FOUND: "Площадка не найдена.",
      generic: "Запрос не выполнен: {{title}}",
    },
    builder: {
      title: "Новый сценарий",
      name: "Название",
      namePlaceholder: "Скрутка стоит 5 дней",
      changes: "Что меняется",
      addKind: "Вид изменения",
      add: "Добавить изменение",
      remove: "Убрать",
      removeAria: "Убрать изменение {{n}}",
      row: "Изменение {{n}}",
      limit: "Не больше {{count}} изменений в одном сценарии.",
      empty: "Добавьте хотя бы одно изменение.",
      zoneNote: "Время указано в поясе площадки ({{offset}}).",
      submit: "Создать и рассчитать",
      submitting: "Создание…",
      cancel: "Отмена",
      workCenter: "Рабочий центр",
      chooseWorkCenter: "Выберите рабочий центр",
      noWorkCenters: "На площадке нет действующих рабочих центров.",
      starts: "Начало",
      ends: "Конец",
      capacityFactor: "Коэффициент мощности",
      product: "Продукт",
      productChosen: "Продукт: {{product}}",
      changeProduct: "Сменить продукт",
      qty: "Количество",
      dueDate: "Срок",
      priority: "Приоритет",
      priorityRush: "{{n}}, срочно",
      priorityNormal: "{{n}}, обычный",
      priorityLow: "{{n}}, низкий",
      shift: "Смена",
      chooseShift: "Выберите смену",
      efficiency: "Эффективность, %",
      order: "Заказ",
      chooseOrder: "Выберите заказ",
      noOrders: "На площадке нет подтверждённых заказов.",
      line: "Строка",
      chooseLine: "Выберите строку",
      lineOption: "Строка {{line}}: {{product}}",
      ordersError: "Не удалось загрузить заказы.",
      fixErrors: "Проверьте отмеченные поля.",
      phone: "Сценарии создаются на большом экране.",
      issue: {
        required: "Заполните поле.",
        window: "Конец должен быть позже начала, не дальше 92 дней.",
        factor: "Коэффициент от 0,01 до 3,00.",
        qty: "Количество больше 0, не более трёх знаков после запятой.",
        efficiency: "Целое число от 10 до 200.",
        date: "Укажите дату.",
        name: "Дайте сценарию название не длиннее 120 знаков.",
      },
    },
    result: {
      back: "Все сценарии",
      loading: "Загрузка сценария…",
      loadError: "Не удалось загрузить сценарий.",
      notFoundTitle: "Сценарий не найден",
      notFoundBody: "Возможно, его отбросили и удалили.",
      solving: "Расчёт на копии плана… {{elapsed}}",
      solvingBody: "Действующий план не меняется, пока сценарий не применят.",
      failedTitle: "Расчёт не удался",
      solveAgain: "Рассчитать заново",
      superseded: "Основан на версии {{version}}; на заводе уже всё изменилось.",
      base: "Сравнение с версией {{version}} опубликованного графика.",
      changes: "Что меняется",
      hypothesis: {
        add_shift: "Дополнительная смена на {{wc}}, с {{start}} до {{end}}, мощность × {{factor}}",
        machine_down: "{{wc}} стоит с {{start}} до {{end}}",
        add_order:
          "Новый заказ: {{qty}} продукта {{product}}, срок {{date}}, приоритет {{priority}}",
        change_efficiency: "{{wc}}, смена {{shift}} на {{pct}} %",
        drop_order: "Одна строка заказа убрана из плана",
      },
      saved: "Сохраняется при применении",
      notSaved: "Не сохраняется: только отвечает на вопрос",
      kpis: "Результаты",
      kpi: {
        lateOrders: "Просроченные заказы",
        lateDays: "Дни просрочки",
        setup: "Минуты переналадки",
        makespan: "Часы до окончания всей работы",
      },
      kpiSub: "{{base}} → {{scenario}}",
      utilization: "Загрузка по рабочим центрам",
      util: {
        workCenter: "Рабочий центр",
        base: "Опубликованный",
        scenario: "Сценарий",
        delta: "Изменение",
      },
      pct: "{{pct}} %",
      noUtil: "Загрузка рабочих центров не меняется.",
      cost: "Влияние на затраты",
      overtime: "Сверхурочные",
      costUnpriced: {
        no_rate: "Без оценки: у рабочего центра нет ставки труда.",
        currency_mismatch: "Без оценки: ставки труда в другой валюте.",
      },
      latePenalty: "Штрафы за просрочку не оцениваются.",
      slipped: "Заказы, которые закончатся позже ({{count}})",
      recovered: "Заказы, которые закончатся раньше ({{count}})",
      slippedNone: "Ни один заказ не закончится позже.",
      recoveredNone: "Ни один заказ не закончится раньше.",
      more: "Ещё {{count}} не показано.",
      shift: {
        order: "Заказ",
        customer: "Клиент",
        base: "Окончание по графику",
        scenario: "Окончание в сценарии",
        days: "Дни",
      },
      unplaced: "Не размещён",
      whatIfOrder: "Заказ сценария {{n}}",
      lanes: "График сценария",
      lanesNone: "В этом окне ничего не запланировано.",
      lanesError: "Не удалось загрузить график сценария.",
      lanesLoading: "Загрузка графика сценария…",
      earlier: "Раньше",
      later: "Позже",
      window: "{{from}} — {{to}}",
      zoneLine: "Время указано в поясе площадки ({{offset}}).",
      lane: "Рабочий центр",
      promote: "Применить",
      promoteTip: "Сохранить можно только добавленные смены и изменения эффективности.",
      discard: "Отбросить",
      duplicate: "Дублировать",
      copyName: "{{name}} (копия)",
      promoted: "Применил(а) {{who}}, {{time}}",
      discarded: "Отброшен {{time}}",
      applied:
        "Записано в календарь: дополнительных смен {{shifts}}, копий графика смен {{patterns}}.",
      phoneNote: "Применять, отбрасывать и дублировать можно на большом экране.",
      confirm: {
        title: "Применить этот сценарий?",
        body: "Изменения запишутся в действующий календарь, и будет запрошен новый действующий график.",
        writes: "Будет записано",
        skips: "Не будет записано",
        shiftLine: "Дополнительная смена на {{wc}}, с {{start}} до {{end}}",
        patternLine:
          "Копия графика смен {{wc}}, смена {{shift}} на {{pct}} %, со следующего рабочего дня",
        submit: "Применить",
        submitting: "Применение…",
      },
      discardConfirm: {
        title: "Отбросить этот сценарий?",
        body: "Сценарий и его график удаляются через 30 дней.",
        submit: "Отбросить",
      },
      done: {
        solve: "Расчёт запущен заново.",
        discard: "Сценарий отброшен.",
        promote: "Применено. Рассчитывается новый действующий график.",
        duplicate: "Копия создана и рассчитывается.",
      },
    },
  },
  origin: {
    fromPlannedOrder: "Из планового заказа",
    fromPlannedOrderNo: "Из {{number}}",
  },
  grid: {
    label: "Количества по неделям",
    product: "Изделие",
    cell: "{{product}}, {{week}}",
    quantity: "Количество",
    reason: "Причина изменения",
    commit: "Применить",
    showDetails: "Показать подробности: {{product}}",
    hideDetails: "Скрыть подробности: {{product}}",
    frozen: "Заморожено, изменить нельзя",
    overridden: "Изменено вручную",
    dropped: "Ручное изменение снято",
    edited: "Ещё не сохранено",
    busy: "Сохранение",
    previousWeek: "Предыдущая неделя",
    nextWeek: "Следующая неделя",
    phoneWeek: "Неделя {{week}}",
    invalid: {
      not_number: "Введите число, 0 или больше.",
      precision: "Не более трёх знаков после запятой.",
    },
  },
};
